<!-- views/ads/index.vue -->
<template>
  <div class="ad-list">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <h2>广告管理</h2>
        <el-breadcrumb separator="/" v-if="routeQueryAdgroupName">
          <el-breadcrumb-item :to="{ path: '/adgroups' }">广告组管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{ routeQueryAdgroupName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="header-actions">
        <el-button
            type="primary"
            icon="el-icon-plus"
            @click="handleCreate"
            class="create-ad-btn"
        >
          批量创建广告
        </el-button>

      </div>
    </div>


    <!-- 筛选栏 -->
    <el-card shadow="never" class="filter-card">

      <el-form :model="filter" inline>
        <el-form-item label="广告主">
          <el-select
              v-model="filter.advertiser_id"
              placeholder="请选择广告主"
              clearable
              filterable              style="width: 380px"
              @change="handleAdvertiserChange"
          >
            <el-option
                v-for="item in advertisers"
                :key="item.advertiser_id"
                :label="`${item.advertiser_name} (${item.advertiser_id})`"
                :value="item.advertiser_id"
            />
          </el-select>
        </el-form-item>
<!--      <el-form :model="filter" inline>-->
<!--        <el-form-item label="广告名称">-->
<!--          <el-input-->
<!--              v-model="filter.ad_name"-->
<!--              placeholder="请输入广告名称"-->
<!--              clearable-->
<!--              style="width: 200px"-->
<!--          />-->
<!--        </el-form-item>-->

        <el-form-item label="所属广告组" v-if="!routeQueryAdgroupId">
          <el-select
              v-model="filter.adgroup_id"
              placeholder="请选择"
              clearable
              filterable
              style="width: 200px"
          >
            <el-option
                v-for="item in adgroupOptions"
                :key="item.adgroup_id"
                :label="item.adgroup_name"
                :value="item.adgroup_id"
            />
          </el-select>
        </el-form-item>

<!--        <el-form-item label="广告格式">-->
<!--          <el-select-->
<!--              v-model="filter.ad_format"-->
<!--              placeholder="全部"-->
<!--              clearable-->
<!--              style="width: 120px"-->
<!--          >-->
<!--            <el-option label="单视频" value="SINGLE_VIDEO"/>-->
<!--            <el-option label="轮播图" value="CAROUSEL_ADS"/>-->
<!--            <el-option label="商品轮播" value="CATALOG_CAROUSEL"/>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="审核状态">-->
<!--          <el-select-->
<!--              v-model="filter.review_status"-->
<!--              placeholder="全部"-->
<!--              clearable-->
<!--              style="width: 120px"-->
<!--          >-->
<!--            <el-option label="审核中" value="AUDIT"/>-->
<!--            <el-option label="通过" value="ALL_AVAILABLE"/>-->
<!--            <el-option label="部分通过" value="PART_AVAILABLE"/>-->
<!--            <el-option label="拒绝" value="UNAVAILABLE"/>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="状态">-->
<!--          <el-select-->
<!--              v-model="filter.operation_status"-->
<!--              placeholder="全部"-->
<!--              clearable-->
<!--              style="width: 100px"-->
<!--          >-->
<!--            <el-option label="启用" value="ENABLE"/>-->
<!--            <el-option label="暂停" value="DISABLE"/>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="创建时间">-->
<!--          <el-date-picker-->
<!--              v-model="dateRange"-->
<!--              type="daterange"-->
<!--              range-separator="至"-->
<!--              start-placeholder="开始日期"-->
<!--              end-placeholder="结束日期"-->
<!--              value-format="yyyy-MM-dd HH:mm:ss"-->
<!--              style="width: 280px"-->
<!--          />-->
<!--        </el-form-item>-->

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <el-table
          :data="ads"
          v-loading="loading" style="width: 100%"
          :key="tableKey"
          :row-key="getRowKey"
      >
        <!-- 动态列 -->
        <template v-for="field in displayFields">
          <!-- ID 列 -->
          <el-table-column
              v-if="field.key === 'smart_plus_ad_id'"
              :key="field.key"
              :label="'广告信息'"
              :min-width="250"
          >
            <template slot-scope="{ row }">
              <div class="ad-info-cell">
                <div class="ad-name-row">{{ row.ad_name || '-' }}</div>
                <div class="ad-id-row">
                  <el-tooltip :content="row.smart_plus_ad_id" placement="top">
                    <span class="ad-id-text">{{ row.smart_plus_ad_id | truncate(16) }}</span>
                  </el-tooltip>
                  <i
                      class="el-icon-document-copy copy-icon"
                      @click="copyToClipboard(row.smart_plus_ad_id)"
                  ></i>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- 跳过单独的广告名称列 -->
          <el-table-column
              v-else-if="field.key === 'ad_name'"
              :key="field.key + '_skip'"
              v-show="false"
          >
          </el-table-column>

          <!-- 广告格式列 -->
          <el-table-column
              v-else-if="field.key === 'ad_format'"
              :key="field.key"
              :label="field.label"
              :width="field.width || 100"
          >
            <template slot-scope="{ row }">
              <el-tag :type="getAdFormatType(row.ad_format)" size="small">
                {{ getAdFormatLabel(row.ad_format) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 创意预览列 -->
          <el-table-column
              v-else-if="field.key === 'creative_preview'"
              :key="field.key"
              :label="field.label"
              :width="field.width || 120"
          >
            <template slot-scope="{ row }">
              <el-button
                  type="text"
                  size="small"
                  @click="handlePreview(row)"
                  :disabled="row.operation_status !== 'ENABLE'"
              >
                预览广告
              </el-button>
            </template>
          </el-table-column>

          <!-- 审核状态列 -->
          <el-table-column
              v-else-if="field.key === 'review_status'"
              :key="field.key"
              :label="field.label"
              :width="field.width || 100"
          >
            <template slot-scope="{ row }">
              <review-status-tag :status="row.review_status"/>
            </template>
          </el-table-column>

          <!-- 状态列 -->
          <el-table-column
              v-else-if="field.key === 'operation_status'"
              :key="field.key"
              :prop="field.key"
              :label="field.label"
              :width="field.width || 100"
          >
            <template slot-scope="{ row }">
              <status-tag :status="row.operation_status"/>
            </template>
          </el-table-column>

          <!-- 时间列 -->
          <el-table-column
              v-else-if="field.key === 'create_time' || field.key === 'modify_time'"
              :key="field.key"
              :prop="field.key"
              :label="field.label"
              :width="field.width || 230"
          >
            <template slot-scope="{ row }">
              <div class="time-text">{{ formatTime(row[field.key]) }}</div>
            </template>
          </el-table-column>

          <!-- 普通文本列 -->
          <el-table-column
              v-else
              :key="field.key"
              :prop="field.key"
              :label="field.label"
              :width="field.width"
              :min-width="field.minWidth || 120"
              :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              {{ formatFieldValue(row[field.key]) }}
            </template>
          </el-table-column>
        </template>

        <!-- 操作列 -->
        <el-table-column label="操作" width="260">
          <template slot-scope="{ row }">
<!--            <el-button-->
<!--                type="text"-->
<!--                size="small"-->
<!--                @click="handleEdit(row)"-->
<!--            >-->
<!--              编辑-->
<!--            </el-button>-->
            <el-button
                v-if="row.operation_status === 'ENABLE'"
                type="text"
                size="small"
                @click="handlePause(row)"
            >
              暂停
            </el-button>
            <el-button
                v-else-if="row.operation_status === 'DISABLE'"
                type="text"
                size="small"
                @click="handleResume(row)"
            >
              启用
            </el-button>
            <el-button
                type="text"
                size="small" style="color: #f56c6c"
                @click="handleDelete(row)"
            >
              删除
            </el-button>
            <el-button
                type="text"
                size="small"
                @click="handleViewReview(row)"
            >
              审核详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
            background
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
        />
      </div>
    </el-card>

<!--    //新建广告-->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="50%"
        @close="handleDialogClose"
        class="ad-dialog"
        :close-on-click-modal="false"
    >
      <!-- 多开窗口模式 -->
      <div v-if="!isEdit" class="batch-mode-header">
        <el-alert
            title="批量创建模式：可以为不同广告主分别配置广告，最后统一提交"
            type="info"
            :closable="false"
            show-icon
        />
        <div class="batch-controls">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addBatchForm">
            添加广告主窗口
          </el-button>
          <el-button
              type="warning"
              size="small"
              icon="el-icon-copy-document"
              @click="duplicateLastForm"
              :disabled="batchForms.length === 0"
          >
            复制上一个窗口
          </el-button>
          <span class="batch-count">当前共 {{ batchForms.length }} 个窗口</span>
        </div>
      </div>

      <!-- 全局视频素材库（仅创建模式显示） -->
      <div v-if="!isEdit" class="global-video-library">
        <el-divider content-position="left">
          <i class="el-icon-video-camera"></i> 全局视频素材库
        </el-divider>

        <el-card shadow="never" class="library-card">
          <div class="library-actions">
            <el-button
                v-if="globalVideoLibrary.length > 0"
                size="small"
                :icon="isAllSelected() ? 'el-icon-check' : 'el-icon-circle-check'"
                @click="toggleSelectAll"
            >
              {{ isAllSelected() ? '取消全选' : '全选' }}
            </el-button>
            <el-button
                type="primary"
                size="small"
                icon="el-icon-search"
                @click="showServerMaterials"
            >
              服务器素材
            </el-button>
            <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                @click="clearGlobalLibrary"
                :disabled="globalVideoLibrary.length === 0"
            >
              清空素材库
            </el-button>
          </div>

<!--          <div class="library-upload-area">-->
<!--            <el-upload-->
<!--                class="video-upload"-->
<!--                action="#"-->
<!--                :http-request="handleGlobalVideoUpload"-->
<!--                :show-file-list="false"-->
<!--                accept="video/mp4,video/quicktime"-->
<!--                multiple-->
<!--            >-->
<!--              <div class="upload-trigger" :class="{ 'is-uploading': globalUploading }">-->
<!--                <i v-if="!globalUploading" class="el-icon-upload2"></i>-->
<!--                <i v-else class="el-icon-loading"></i>-->
<!--                <span>{{ globalUploading ? `上传中... (${globalUploadingCount}/${globalTotalCount})` : '点击上传视频到素材库（支持多选）' }}</span>-->
<!--                <span class="tip">支持 MP4、MOV 格式，≤500MB</span>-->
<!--              </div>-->
<!--            </el-upload>-->
<!--          </div>-->

          <div v-if="globalVideoLibrary.length > 0" class="library-videos-grid">
            <div
                v-for="(video, vIndex) in globalVideoLibrary"
                :key="vIndex"
                class="library-video-item"
            >
              <el-checkbox
                  v-model="video.selected"
                  class="video-checkbox"
              ></el-checkbox>
              <el-button
                  type="text"
                  icon="el-icon-close"
                  class="video-delete-btn"
                  @click="removeFromGlobalLibrary(vIndex)"
              ></el-button>
              <div class="video-preview-wrapper">
                <video
                    :src="getVideoUrl(video)"
                    controls                    style="width: 100%; height: 100%;"
                ></video>
              </div>
              <div class="video-info-mini">
                <span class="video-index">#{{ vIndex + 1 }}</span>
                <el-tooltip :content="getVideoFileName(video)" placement="top">
                  <span class="video-name">{{ getVideoFileName(video) }}</span>
                </el-tooltip>
              </div>
              <div v-if="!hasVideoCover(video)" class="no-cover-warning">
                <i class="el-icon-warning"></i>
              </div>
              <el-button
                  v-if="!hasVideoCover(video)"
                  type="text"
                  icon="el-icon-picture"
                  class="reupload-cover-btn"
                  @click="reuploadVideoCover(vIndex)"
              >
                重新上传封面
              </el-button>
            </div>
          </div>

          <el-empty
              v-else
              description="暂无视频，请上传"
              :image-size="80"
          />
        </el-card>

        <el-divider content-position="left">
          <i class="el-icon-setting"></i> 视频分配概览
        </el-divider>

        <el-card shadow="never" class="allocation-config-card">
          <div class="allocation-summary">
            <el-alert
                v-if="allocationSummary.show"
                :title="allocationSummary.title"
                :type="allocationSummary.type"
                :closable="false"
                show-icon
            >
              <div slot="default" v-html="allocationSummary.message"></div>
            </el-alert>

            <div class="allocation-actions">
              <el-button
                  type="success"
                  size="small"
                  icon="el-icon-magic-stick"
                  @click="applyRecommendedToAllWindows"
                  :disabled="!canAllocate"
              >
                一键应用推荐值到所有窗口
              </el-button>
              <el-button
                  type="primary"
                  size="small"
                  @click="autoAllocateVideos"
                  :disabled="!canAllocate"
              >
                一键分配视频到各窗口
              </el-button>
            </div>

            <div v-if="hasRecommendationAvailable" class="recommendation-hint">
              <i class="el-icon-info"></i>
              推荐值 = 全局选中视频总数 ÷ 所有窗口总广告数，确保视频均匀分配到每个广告
            </div>
          </div>
        </el-card>
      </div>

      <!-- 单表单模式（编辑）或多窗口滚动容器 -->
      <div class="form-container" :class="{ 'batch-mode': !isEdit }">
        <!-- 批量模式：显示多个表单卡片 -->
        <template v-if="!isEdit">
          <el-collapse v-model="activeCollapseNames" class="batch-forms-collapse">
            <el-collapse-item
                v-for="(form, index) in batchForms"
                :key="index"
                :name="index"
                class="batch-form-item"
            >
              <template slot="title">
                <div class="collapse-title">
                  <el-tag :type="getAdvertiserTagType(form.advertiser_id)" size="small">
                    {{ getAdvertiserName(form.advertiser_id) || '未选择广告主' }}
                  </el-tag>
                  <span class="form-index">窗口 {{ index + 1 }}</span>
                  <el-tag
                      v-if="form.allocatedVideos && form.allocatedVideos.length > 0"
                      type="success"
                      size="mini"
                  >
                    已分配 {{ form.allocatedVideos.length }} 个视频
                  </el-tag>
                  <el-tag
                      v-if="form.adgroup_ids && form.adgroup_ids.length > 0"
                      type="warning"
                      size="mini"
                  >
                    {{ form.adgroup_ids.length }} 个广告组
                  </el-tag>
                  <el-button
                      type="text"
                      icon="el-icon-delete"
                      class="remove-form-btn"
                      @click.stop="removeBatchForm(index)"
                      v-if="batchForms.length > 1"
                  >
                    删除此窗口
                  </el-button>
                </div>
              </template>

              <el-form
                  :ref="'batchForm_' + index"
                  :model="form"
                  :rules="formRules"
                  label-width="120px"
                  class="batch-single-form"
              >
                <!-- 基础信息 -->
                <el-divider content-position="left">基础信息</el-divider>

                <el-form-item label="广告主" prop="advertiser_id">
                  <el-select
                      v-model="form.advertiser_id"
                      placeholder="请选择广告主"
                      clearable
                      filterable                      style="width: 380px"
                      @change="handleBatchFormAdvertiserChange(index)"
                      @visible-change="(visible) => handleAdgroupDropdownVisibleChange(visible, index)"
                  >
                    <el-option
                        v-for="item in advertisers"
                        :key="item.advertiser_id"
                        :label="`${item.advertiser_name} (${item.advertiser_id})`"
                        :value="item.advertiser_id"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item label="广告名称" prop="ad_name">
                  <el-input v-model="form.ad_name" placeholder="请输入广告名称（留空则自动生成）"/>
                </el-form-item>

                <el-form-item label="所属广告组" prop="adgroup_ids" v-if="!routeQueryAdgroupId">
                  <div class="adgroup-selector-wrapper">
                    <el-select
                        v-model="form.adgroup_ids"
                        placeholder="请选择广告组（支持多选）"
                        multiple
                        collapse-tags
                        filterable                        style="width: 100%"
                        :loading="form.adgroupLoading"

                        @change="handleFormAdgroupChange(index)"
                    >
                      <el-option
                          v-for="item in form.adgroupOptions"
                          :key="item.adgroup_id"
                          :label="item.adgroup_name"
                          :value="item.adgroup_id"
                      />
                    </el-select>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="openCreateAdgroupDialog(index)"                        style="margin-top: 8px; width: 100%"
                    >
                      + 新建广告组
                    </el-button>
                  </div>
                  <div class="form-tip" v-if="form.adgroup_ids.length > 0">
                    已选择 {{ form.adgroup_ids.length }} 个广告组
                  </div>
                </el-form-item>

                <el-form-item label="总广告数量" prop="adCount">
                  <el-input-number
                      v-model="form.adCount"
                      :min="1"
                      :max="100"
                      :step="1"                      style="width: 200px"
                      @change="handleFormAdCountChange(index)"
                  ></el-input-number>
                  <span class="form-tip" style="margin-left: 12px">
                    将为此窗口创建 {{ form.adCount }} 个广告
                  </span>
                </el-form-item>

                <el-form-item label="启用状态">
                  <el-switch
                      v-model="form.operation_status"
                      active-value="ENABLE"
                      inactive-value="DISABLE"
                      active-text="启用"
                      inactive-text="禁用"
                  />
                  <div class="form-tip" style="margin-top: 4px">
                    {{ form.operation_status === 'ENABLE' ? '广告创建后将立即启用' : '广告创建后将处于禁用状态，需手动启用' }}
                  </div>
                </el-form-item>

                <el-form-item label="每广告视频数">
                  <el-input-number
                      v-model="form.videosPerAd"
                      :min="1"
                      :max="20"
                      :step="1"                      style="width: 200px"
                      @change="handleFormAdCountChange(index)"
                  ></el-input-number>
                  <span class="form-tip" style="margin-left: 12px">
                    每个广告将分配 {{ form.videosPerAd }} 个视频
                  </span>
                  <el-button
                      v-if="getRecommendedVideosPerAd(form) > 0"
                      type="text"
                      size="small"
                      icon="el-icon-magic-stick"
                      @click="applyRecommendedVideosPerAd(index)"                      style="margin-left: 8px; color: #67c23a"
                  >
                    推荐: {{ getRecommendedVideosPerAd(form) }} ({{ getTotalSelectedVideos() }}视频/{{ getTotalAdsNeeded() }}广告)
                  </el-button>
                </el-form-item>
                <!-- 已分配视频预览 -->
                <el-form-item label="已分配视频" v-if="form.allocatedVideos && form.allocatedVideos.length > 0">
                  <div class="allocated-videos-preview">
                    <div
                        v-for="(video, vIndex) in form.allocatedVideos"
                        :key="vIndex"
                        class="allocated-video-item"
                    >
                      <div class="video-preview-mini">
                        <video
                            :src="getVideoUrl(video)"                            style="width: 78px; height: 128px;"
                        ></video>
                      </div>
                      <span class="video-label">#{{ vIndex + 1 }}</span>
                    </div>
                  </div>
                  <div class="form-tip" style="margin-top: 8px">
                    共 {{ form.allocatedVideos.length }} 个视频，每个广告约分配 {{ Math.floor(form.allocatedVideos.length / form.adCount) }} 个
                  </div>
                </el-form-item>

                <!-- 广告文案 -->
                <el-divider content-position="left">广告文案</el-divider>

                <el-form-item label="广告文案">
                  <div class="ad-text-list">
                    <div
                        v-for="(text, tIndex) in form.ad_text_list"
                        :key="tIndex"
                        class="ad-text-item"
                    >
                      <el-input
                          v-model="text.ad_text"
                          placeholder="请输入广告文案"
                          maxlength="512"
                          show-word-limit                          style="width: 100%"
                      />
                      <el-button
                          type="text"
                          icon="el-icon-delete"                          style="color: #f56c6c"
                          @click="removeBatchFormAdText(index, tIndex)"
                          v-if="form.ad_text_list.length > 1"
                      />
                    </div>
                    <el-button
                        type="dashed"
                        icon="el-icon-plus"
                        size="small"
                        @click="addBatchFormAdText(index)"
                        v-if="form.ad_text_list.length < 5"
                    >
                      添加文案
                    </el-button>
                  </div>
                </el-form-item>

                <!-- 行动号召 -->
                <el-divider content-position="left">行动号召</el-divider>

                <el-form-item label="推荐文案">
                  <el-select
                      v-model="form.selectedCtaList"
                      multiple
                      collapse-tags
                      placeholder="请选择推荐文案（可选）"                      style="width: 100%"
                      :loading="ctaLoading"
                  >
                    <el-option
                        v-for="item in ctaRecommendList"
                        :key="item.asset_content"
                        :label="item.asset_content"
                        :value="item.asset_content"
                    >
                      <span style="float: left">{{ item.asset_content }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">
                        ID: {{ item.asset_ids.join(', ') }}
                      </span>
                    </el-option>
                  </el-select>
                  <div class="form-tip">从推荐文案中选择，将自动创建素材包</div>
                </el-form-item>

                <!-- 落地页 -->
                <el-divider content-position="left">落地页</el-divider>

                <el-form-item label="落地页URL">
                  <el-input
                      v-model="form.landing_page_url_list[0].landing_page_url"
                      placeholder="请输入落地页URL"
                  />
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>

          <div v-if="batchForms.length === 0" class="empty-batch-hint">
            <el-empty description="请点击右上角「添加广告主窗口」开始创建广告" />
          </div>
        </template>
      </div>

      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
            v-if="!isEdit"
            type="primary"
            :loading="submitLoading"
            @click="handleBatchSubmit"
            :disabled="batchForms.length === 0"
        >
          一键全部保存 ({{ batchForms.length }} 个窗口)
        </el-button>
<!--        <el-button-->
<!--            v-else-->
<!--            type="primary"-->
<!--            :loading="submitLoading"-->
<!--            @click="handleSubmit"-->
<!--        >-->
<!--          创建广告-->
<!--        </el-button>-->
      </span>
    </el-dialog>

    <!-- 预览弹窗 -->
    <el-dialog
        title="广告预览"
        :visible.sync="previewDialogVisible"
        width="400px"
        center
    >
      <div class="preview-container">
        <div class="preview-iframe-wrapper">
          <iframe :src="previewUrl" frameborder="0" class="preview-iframe"></iframe>
        </div>
        <div class="preview-link">
          <el-input v-model="previewUrl" readonly>
            <el-button slot="append" icon="el-icon-document-copy" @click="copyPreviewLink">复制链接</el-button>
          </el-input>
        </div>
      </div>
    </el-dialog>

    <!-- 审核详情弹窗 -->
    <el-dialog
        title="审核详情"
        :visible.sync="reviewDialogVisible"
        width="600px"
    >
      <div v-if="reviewInfo" class="review-info">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="广告ID">
            {{ reviewInfo.smart_plus_ad_id }}
          </el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <review-status-tag :status="reviewInfo.review_status"/>
          </el-descriptions-item>
          <el-descriptions-item label="申诉状态" v-if="reviewInfo.appeal_status">
            <el-tag :type="getAppealStatusType(reviewInfo.appeal_status)" size="small">
              {{ getAppealStatusLabel(reviewInfo.appeal_status) }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 拒绝原因 -->
        <div v-if="reviewInfo.reject_info && reviewInfo.reject_info.length" class="reject-info">
          <h4>拒绝原因</h4>
          <div
              v-for="(reject, idx) in reviewInfo.reject_info"
              :key="idx"
              class="reject-item"
          >
            <div class="reject-reasons">
              <span class="label">原因：</span>
              <span class="value">{{ reject.reasons.join('；') }}</span>
            </div>
            <div class="reject-suggestion" v-if="reject.suggestion">
              <span class="label">建议：</span>
              <span class="value">{{ reject.suggestion }}</span>
            </div>
          </div>
        </div>

        <!-- 申诉表单 -->
        <el-divider v-if="reviewInfo.review_status === 'UNAVAILABLE'">申诉</el-divider>

        <el-form v-if="reviewInfo.review_status === 'UNAVAILABLE'" label-width="100px">
          <el-form-item label="申诉理由">
            <el-input
                type="textarea"
                v-model="appealForm.reason"
                rows="3"
                placeholder="请填写申诉理由"
            />
          </el-form-item>
          <el-form-item label="附件链接">
            <el-input
                v-model="appealForm.attachment"
                placeholder="请输入附件URL（多个用逗号分隔）"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAppeal">提交申诉</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>


    <!-- 新建广告组弹窗 -->
    <el-dialog
        title="批量创建广告组"
        :visible.sync="createAdgroupDialogVisible"
        width="700px"
        @close="handleCreateAdgroupDialogClose"
        class="create-adgroup-dialog"
    >
      <el-alert
          title="为当前窗口批量创建广告组（同时会创建对应的广告系列）"
          type="info"
          :closable="false"
          show-icon          style="margin-bottom: 16px"
      />

      <el-form
          ref="createAdgroupForm"
          :model="createAdgroupFormData"
          :rules="createAdgroupFormRules"
          label-width="140px"
      >
        <el-form-item label="广告主">
          <el-input :value="getAdvertiserName(createAdgroupFormData.advertiser_id)" disabled />
        </el-form-item>

        <el-form-item label="创建数量" prop="count">
          <el-input-number
              v-model="createAdgroupFormData.count"
              :min="1"
              :max="50"
              :step="1"              style="width: 200px"
          />
          <span class="form-tip">将创建 {{ createAdgroupFormData.count }} 个广告系列和广告组</span>
        </el-form-item>

        <el-divider content-position="left">广告系列配置</el-divider>

        <el-form-item label="广告目标" prop="objective_type">
          <el-select v-model="createAdgroupFormData.objective_type" placeholder="请选择广告目标" style="width: 100%">
            <el-option label="应用推广" value="APP_PROMOTION" />
          </el-select>
        </el-form-item>

        <el-form-item label="预算模式" prop="budget_mode">
          <el-radio-group v-model="createAdgroupFormData.budget_mode">
            <el-radio label="BUDGET_MODE_DYNAMIC_DAILY_BUDGET">动态每日预算</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="预算金额" prop="budget">
          <el-input-number
              v-model="createAdgroupFormData.budget"
              :min="50"
              :step="50"
              placeholder="单位：元"
          />
          <span class="form-tip">¥{{ (createAdgroupFormData.budget || 0).toFixed(2) }}元/天</span>
        </el-form-item>

        <el-divider content-position="left">广告组基础配置</el-divider>

        <el-form-item label="推广类型" prop="promotion_type">
          <el-select v-model="createAdgroupFormData.promotion_type" placeholder="请选择" style="width: 100%">
            <el-option label="小游戏" value="MINI_GAME" />
          </el-select>
        </el-form-item>

        <el-form-item label="小游戏/小程序" prop="minis_id" v-if="createAdgroupFormData.promotion_type === 'MINI_GAME'">
          <el-select
              v-model="createAdgroupFormData.minis_id"
              placeholder="请选择小游戏/小程序"
              filterable              style="width: 100%"
          >
            <el-option
                v-for="item in minisOptions"
                :key="item.minis_id"
                :label="item.minis_name"
                :value="item.minis_id"
            />
          </el-select>
          <el-button
              type="text"
              size="small"
              @click="loadMinisOptions"
              :loading="minisLoading"
          >
            刷新列表
          </el-button>
        </el-form-item>

        <el-form-item label="优化目标" prop="optimization_goal">
          <el-select v-model="createAdgroupFormData.optimization_goal" placeholder="请选择" style="width: 100%">
            <el-option
                v-for="item in optimizationGoalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
            label="转化事件"
            v-if="createAdgroupFormData.optimization_goal === 'CONVERT' || createAdgroupFormData.optimization_goal === 'IN_APP_EVENT'"
            prop="optimization_event"
        >
          <el-input v-model="createAdgroupFormData.optimization_event" placeholder="请输入转化事件名称" />
          <span class="form-tip">如：PURCHASE、ADD_TO_CART、REGISTRATION</span>
        </el-form-item>

        <el-divider content-position="left">出价与预算</el-divider>

        <el-form-item label="出价策略" prop="bid_type">
          <el-radio-group v-model="createAdgroupFormData.bid_type">
            <el-radio label="BID_TYPE_NO_BID">最大转化（系统自动出价）</el-radio>
            <el-radio label="BID_TYPE_CUSTOM">成本控制（手动出价）</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
            v-if="createAdgroupFormData.bid_type === 'BID_TYPE_CUSTOM'"
            label="目标出价"
            prop="conversion_bid_price"
        >
          <el-input-number
              v-model="createAdgroupFormData.conversion_bid_price"
              :min="100"
              :step="50"
              placeholder="单位：分"
          />
          <span class="form-tip">分/转化，¥{{ ((createAdgroupFormData.conversion_bid_price || 0) / 100).toFixed(2) }}元</span>
        </el-form-item>

        <el-form-item
            v-if="createAdgroupFormData.bid_type === 'BID_TYPE_CUSTOM'"
            label="平均点击成本"
            prop="bid_price"
        >
          <el-input-number
              v-model="createAdgroupFormData.bid_price"
              :min="100"
              :step="50"
              placeholder="单位：分"
          />
          <span class="form-tip">分/点击，¥{{ ((createAdgroupFormData.bid_price || 0) / 100).toFixed(2) }}元</span>
        </el-form-item>


        <!-- 价值优化 (VBO) -->
        <template v-if="createAdgroupFormData.optimization_goal === 'VALUE'">
          <el-form-item label="深度出价策略" prop="deep_bid_type">
            <el-select v-model="createAdgroupFormData.deep_bid_type" placeholder="请选择" style="width: 200px">
              <el-option label="最小ROAS" value="VO_MIN_ROAS" />
              <el-option label="最高价值" value="VO_HIGHEST_VALUE" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="createAdgroupFormData.deep_bid_type === 'VO_MIN_ROAS'" label="目标ROAS" prop="roas_bid">
            <el-input-number
                v-model="createAdgroupFormData.roas_bid"
                :min="0.01"
                :max="1000"
                :step="0.01"
                :precision="2"
                placeholder="0.01-1000"
            />
            <span class="form-tip">例如：1.5 表示期望 150% 的回报</span>
          </el-form-item>
        </template>

        <el-divider content-position="left">投放排期</el-divider>

        <el-form-item label="排期类型" prop="schedule_type">
          <el-radio-group v-model="createAdgroupFormData.schedule_type">
            <el-radio label="SCHEDULE_FROM_NOW">立即开始，长期投放</el-radio>
            <el-radio label="SCHEDULE_START_END">指定开始和结束时间</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="开始时间" prop="schedule_start_time">
          <el-date-picker
              v-model="createAdgroupFormData.schedule_start_time"
              type="datetime"
              placeholder="选择开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="startTimeOptions"
          />
        </el-form-item>

        <el-form-item
            v-if="createAdgroupFormData.schedule_type === 'SCHEDULE_START_END'"
            label="结束时间"
            prop="schedule_end_time"
        >
          <el-date-picker
              v-model="createAdgroupFormData.schedule_end_time"
              type="datetime"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="endTimeOptions"
          />
        </el-form-item>

        <el-divider content-position="left">投放位置</el-divider>

        <el-form-item label="投放策略" prop="placement_type">
          <el-radio-group v-model="createAdgroupFormData.placement_type">
            <el-radio label="PLACEMENT_TYPE_AUTOMATIC">自动投放</el-radio>
            <el-radio label="PLACEMENT_TYPE_NORMAL">手动选择</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
            v-if="createAdgroupFormData.placement_type === 'PLACEMENT_TYPE_NORMAL'"
            label="选择位置"
            prop="placements"
        >
          <el-checkbox-group v-model="createAdgroupFormData.placements">
            <el-checkbox label="PLACEMENT_TIKTOK">TikTok</el-checkbox>
            <el-checkbox label="PLACEMENT_PANGLE">Pangle</el-checkbox>
            <el-checkbox label="PLACEMENT_GLOBAL_APP_BUNDLE">Global App Bundle</el-checkbox>
          </el-checkbox-group>
        </el-form-item>



        <!-- 定向设置 -->
        <el-divider content-position="left">定向设置</el-divider>

        <!-- 地理位置 -->
        <el-form-item label="地理位置">
          <div class="location-selector">
            <el-select
                v-model="createAdgroupFormData.targeting_location_ids"
                multiple
                filterable
                collapse-tags
                placeholder="请选择地理位置"                style="width: 100%"
            >
              <el-option
                  v-for="item in locationOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </div>
        </el-form-item>

        <!-- 语言 -->
        <el-form-item label="语言">
          <el-select
              v-model="createAdgroupFormData.targeting_languages"
              multiple
              placeholder="请选择语言"              style="width: 100%"
          >
            <el-option label="阿拉伯语" value="ar" />
            <el-option label="阿萨姆语" value="as" />
            <el-option label="哈里亚纳语" value="bgc" />
            <el-option label="比哈尔语" value="bh" />
            <el-option label="孟加拉语" value="bn" />
            <el-option label="捷克语" value="cs" />
            <el-option label="德语" value="de" />
            <el-option label="希腊语" value="el" />
            <el-option label="英语" value="en" />
            <el-option label="西班牙语" value="es" />
            <el-option label="芬兰语" value="fi" />
            <el-option label="法语" value="fr" />
            <el-option label="古吉拉特语" value="gu" />
            <el-option label="希伯来语" value="he" />
            <el-option label="印地语" value="hi" />
            <el-option label="匈牙利语" value="hu" />
            <el-option label="印尼语" value="id" />
            <el-option label="意大利语" value="it" />
            <el-option label="日语" value="ja" />
            <el-option label="卡纳达语" value="kn" />
            <el-option label="韩语" value="ko" />
            <el-option label="马拉雅拉姆语" value="ml" />
            <el-option label="马拉地语" value="mr" />
            <el-option label="马来语" value="ms" />
            <el-option label="荷兰语" value="nl" />
            <el-option label="奥里亚语" value="or" />
            <el-option label="旁遮普语" value="pa" />
            <el-option label="波兰语" value="pl" />
            <el-option label="葡萄牙语" value="pt" />
            <el-option label="拉贾斯坦语" value="raj" />
            <el-option label="罗马尼亚语" value="ro" />
            <el-option label="俄语" value="ru" />
            <el-option label="瑞典语" value="sv" />
            <el-option label="泰米尔语" value="ta" />
            <el-option label="泰卢固语" value="te" />
            <el-option label="泰语" value="th" />
            <el-option label="土耳其语" value="tr" />
            <el-option label="乌克兰语" value="uk" />
            <el-option label="越南语" value="vi" />
            <el-option label="简体中文" value="zh" />
            <el-option label="繁体中文" value="zh-Hant" />
          </el-select>
        </el-form-item>

        <!-- 性别定向 -->
        <el-form-item label="性别定向">
          <el-select
              v-model="createAdgroupFormData.targeting_gender"
              placeholder="请选择性别定向"
              style="width: 100%"
          >
            <el-option
                v-for="(label, value) in genderOptions"
                :key="value"
                :label="label"
                :value="value"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="createAdgroupDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="createAdgroupLoading" @click="handleBatchCreateAdgroups">
          创建 {{ createAdgroupFormData.count }} 个广告组
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="广告创建结果"
        :visible.sync="submitResultDialogVisible"
        width="800px"
        @close="handleSubmitResultDialogClose"
        class="submit-result-dialog"
    >
      <div class="result-summary">
        <el-alert
            :title="`成功: ${submitResults.successList.length} | 失败: ${submitResults.failList.length}`"
            :type="submitResults.failList.length === 0 ? 'success' : 'warning'"
            :closable="false"
            show-icon
        />
      </div>

      <el-tabs v-model="activeResultTab" style="margin-top: 16px">
        <el-tab-pane :label="`成功列表 (${submitResults.successList.length})`" name="success">
          <el-table
              :data="submitResults.successList"
              max-height="400"
              stripe
          >
            <el-table-column label="窗口" width="80">
              <template slot-scope="{ row }">
                <el-tag size="small">窗口{{ row.windowIndex }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="广告序号" width="100">
              <template slot-scope="{ row }">
                广告 {{ row.adIndex }}
              </template>
            </el-table-column>
            <el-table-column label="广告名称" min-width="200">
              <template slot-scope="{ row }">
                {{ row.adName }}
              </template>
            </el-table-column>
            <el-table-column label="广告ID" width="180">
              <template slot-scope="{ row }">
                <span class="id-text">{{ row.adId }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane :label="`失败列表 (${submitResults.failList.length})`" name="fail">
          <div v-if="submitResults.failList.length === 0" class="empty-fail">
            <el-empty description="没有失败的广告" />
          </div>
          <el-table
              v-else
              :data="submitResults.failList"
              max-height="400"
              stripe
          >
            <el-table-column label="窗口" width="80">
              <template slot-scope="{ row }">
                <el-tag size="small" type="danger">窗口{{ row.windowIndex }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="广告序号" width="100">
              <template slot-scope="{ row }">
                广告 {{ row.adIndex }}
              </template>
            </el-table-column>
            <el-table-column label="失败原因" min-width="250">
              <template slot-scope="{ row }">
                <span class="error-text">{{ row.error }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" >
              <template slot-scope="{ row }">
                <el-button
                    v-if="row.canRetry"
                    type="primary"
                    size="small"
                    :loading="row.retrying"
                    @click="retryCreateAd(row)"
                >
                  重试
                </el-button>
                <span v-else class="no-retry-tip">不可重试</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer">
        <el-button @click="submitResultDialogVisible = false">关闭</el-button>
        <el-button
            v-if="submitResults.failList.some(r => r.canRetry)"
            type="primary"
            :loading="retryingAll"
            @click="retryAllFailedAds"
        >
          重试所有失败 ({{ submitResults.failList.filter(r => r.canRetry).length }})
        </el-button>
        <el-button
            type="success"
            @click="handleResultDialogConfirm"
        >
          确认并刷新列表
        </el-button>
      </span>
    </el-dialog>

    <!-- 视频消耗报表组件 -->
    <video-report
        v-if="filter.advertiser_id"
        :advertiser-id="filter.advertiser_id"
        @add-to-library="handleAddVideosToLibrary"
    />

    <div>
      <video-upload-component
          :default-advertiser-id="currentAdvertiserId"
      />
    </div>

    <!-- 服务器素材查询抽屉 -->
    <!-- 服务器素材查询抽屉 -->
    <el-drawer
        title="服务器素材查询"
        :visible.sync="serverMaterialsDrawerVisible"
        direction="rtl"
        size="80%"
        append-to-body
        :destroy-on-close="false"
    >
      <div class="drawer-content">
        <video-record-query
            ref="videoRecordQuery"
            :base-url="baseUrl"
            :advertiser-id="filter.advertiser_id"
            @videos-assigned="handleVideosAssigned"
        />
      </div>
    </el-drawer>
  </div>

</template>

<script>
import {adApi, videoApi, ctaApi, imageApi} from '@/api/ad'
import {adgroupApi} from '@/api/adgroup'
import StatusTag from '@/components/StatusTag'
import ReviewStatusTag from '@/components/ReviewStatusTag'
import FieldSelector from '@/components/FieldSelector'
import {AD_FORMAT, AD_FORMAT_LABEL} from '@/utils/constants'
import {AD_FIELDS, AD_FIELD_LABEL} from '@/utils/adFieldConstants'
import {advertiserApi} from "@/api/advertiserApi";
import {appApi as catalogApi} from "@/api/app";
import {campaignApi} from "@/api/campaign";
import VideoReport from './VideoReport'
import VideoUploadComponent from '@/components/views/ads/VideoUploadComponent.vue'
import VideoRecordQuery from '@/components/views/ads/VideoRecordQuery.vue'

export default {
  name: 'AdList',
  components: {
    StatusTag,
    ReviewStatusTag,
    VideoReport,
    VideoUploadComponent,
    VideoRecordQuery
  },
  data() {
    return {


      serverMaterialsDrawerVisible: false,
      // baseUrl: 'https://tiktoktf.darknight.games/api/api',
      baseUrl: 'https://tiktoktf.darknight.games/api/api',
      currentAdvertiserId: '7598883753192357896',
      STORAGE_KEY: 'ad_list_config',
      ADVERTISER_STORAGE_KEY: 'ad_selected_advertiser',
      VIDEO_LIBRARY_STORAGE_KEY: 'global_video_library',
      ads: [],
      loading: false,
      tableKey: 0,
      adgroupOptions: [],
      pageOptions: [],
      advertisers: [],


      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },

      filter: {
        advertiser_id: '',
        ad_name: '',
        adgroup_id: '',
        ad_format: '',
        review_status: '',
        operation_status: '',

      },
      dateRange: [],

      routeQueryAdgroupId: this.$route.query.adgroupId || '',
      routeQueryAdgroupName: this.$route.query.adgroupName || '',

      allFields: [],
      selectedFields: [],
      defaultFields: [],

      ctaRecommendList: [],
      selectedCtaList: [],
      ctaLoading: false,
      portfolioId: '',

      dialogVisible: false,
      dialogTitle: '创建广告',
      submitLoading: false,
      isEdit: false,
      editAdId: null,

      // 批量模式相关
      batchForms: [],
      activeCollapseNames: [],

      // 全局视频素材库
      globalVideoLibrary: [],
      globalUploading: false,
      globalUploadingCount: 0,
      globalTotalCount: 0,
      currentBatchFiles: [],
      // 视频分配概览
      allocationSummary: {
        show: false,
        title: '',
        message: '',
        type: 'info'
      },
      // 视频分配配置
      allocationConfig: {
        adgroupIds: [],
        adgroupOptions: [],
        adgroupLoading: false,
        videosPerAd: 2
      },
      allocationResult: {
        show: false,
        title: '',
        message: '',
        type: 'info'
      },

      formData: {
        ad_name: '',
        adgroup_ids: [],
        operation_status: 'ENABLE',
        creativeList: [],
        ad_text_list: [{ad_text: ''}],
        call_to_action_list: [{call_to_action: ''}],
        landing_page_url_list: [{landing_page_url: ''}]
      },
      formRules: {
        advertiser_id: [
          {required: true, message: '请选择广告主', trigger: 'change'}
        ],
        adgroup_ids: [
          {required: true, message: '请至少选择一个广告组', trigger: 'change', type: 'array', min: 1}
        ],

      },

      previewDialogVisible: false,
      previewUrl: '',

      reviewDialogVisible: false,
      reviewInfo: null,
      currentReviewAdId: null,
      appealForm: {
        reason: '',
        attachment: ''
      },

      videoUploading: false,
      // 新建广告组相关
      createAdgroupDialogVisible: false,
      createAdgroupLoading: false,
      currentAdgroupFormIndex: null,
      createAdgroupFormData: {
        advertiser_id: '',
        count: 1,
        objective_type: 'APP_PROMOTION',
        budget_mode: 'BUDGET_MODE_DYNAMIC_DAILY_BUDGET',
        budget: 50,
        promotion_type: 'MINI_GAME',
        minis_id: '',
        optimization_goal: 'VALUE',
        optimization_event: 'PURCHASE',
        bid_type: 'BID_TYPE_NO_BID',
        conversion_bid_price: 100,
        bid_price: 100,
        deep_bid_type: '',
        roas_bid: null,
        schedule_type: 'SCHEDULE_FROM_NOW',
        schedule_start_time: '',
        schedule_end_time: '',
        placement_type: 'PLACEMENT_TYPE_NORMAL',
        placements: [],
        targeting_location_ids: ['6252001'],
        targeting_languages: ['en'],
        targeting_gender: 'GENDER_UNLIMITED'
      },
      createAdgroupFormRules: {
        count: [
          { required: true, message: '请输入创建数量', trigger: 'blur' }
        ],
        objective_type: [
          { required: true, message: '请选择广告目标', trigger: 'change' }
        ],
        budget_mode: [
          { required: true, message: '请选择预算模式', trigger: 'change' }
        ],
        budget: [
          { required: true, message: '请输入预算金额', trigger: 'blur' }
        ],
        promotion_type: [
          { required: true, message: '请选择推广类型', trigger: 'change' }
        ],
        minis_id: [
          { required: true, message: '请选择小游戏/小程序', trigger: 'change' }
        ],
        optimization_goal: [
          { required: true, message: '请选择优化目标', trigger: 'change' }
        ],
        schedule_start_time: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ]
      },
      minisOptions: [],
      minisLoading: false,
      locationOptions: [],
      locationLoading: false,
      genderOptions: {
        'GENDER_UNLIMITED': '不限',
        'GENDER_MALE': '男性',
        'GENDER_FEMALE': '女性'
      },
      optimizationGoalOptions: [
        { label: '价值优化', value: 'VALUE' },

      ],
      startTimeOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 28.64e7
        }
      },
      endTimeOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      submitResultDialogVisible: false,
      submitResults: {
        successList: [],
        failList: []
      },
      retryingCount: 0
    }
  },
  computed: {

    username() {
      return this.$store.state.username || this.$store.state.user?.username || '未登录'
    },
    displayFields() {
      const fields = []
      for (const key of this.selectedFields) {
        const fieldConfig = this.allFields.find(f => f.key === key)
        if (fieldConfig) {
          fields.push(fieldConfig)
        }
      }
      return fields
    },

    hasRecommendationAvailable() {
      if (!this.batchForms || this.batchForms.length === 0) {
        return false
      }

      // 检查是否有至少一个窗口已分配视频且设置了广告数
      return this.batchForms.some(form =>
          form.allocatedVideos &&
          form.allocatedVideos.length > 0 &&
          form.adCount > 0
      )
    }
  },
  watch: {
    'globalVideoLibrary': {
      handler() {
        this.saveVideoLibraryToCache()
      },
      deep: true
    }
  }, mounted() {


    console.log('=== 页面加载时的 Store 状态 ===')
    console.log('state.username:', this.$store.state.username)
    console.log('state.user:', this.$store.state.user)
    console.log('state.user.username:', this.$store.state.user?.username)
    console.log('localStorage user:', localStorage.getItem('user'))

    const storedUser = localStorage.getItem('user')
    if (storedUser && !this.$store.state.username) {
      try {
        const user = JSON.parse(storedUser)
        console.log('从 localStorage 恢复用户信息:', user)
        if (user.username) {
          this.$store.commit('setUsername', user.username)
          console.log('已恢复 username:', user.username)
        }
      } catch (e) {
        console.error('解析 localStorage user 失败:', e)
      }
    }
    this.initFields()
    this.loadSelectedFields()
    this.loadAdvertiserSelection()
    this.loadVideoLibraryFromCache()
    this.initData()
  },
  methods: {
    handleVideosAssigned(assignmentData) {
      console.log('收到视频数据:', assignmentData)

      const { videos } = assignmentData

      if (!videos || videos.length === 0) {
        this.$message.warning('没有可分配的视频')
        return
      }

      // 关闭抽屉
      this.serverMaterialsDrawerVisible = false

      // 检查是否有批量表单
      if (!this.batchForms || this.batchForms.length === 0) {
        this.$message.warning('请先打开批量创建广告页面并添加窗口')
        return
      }

      // 检查所有窗口是否都已配置广告组
      const configuredForms = []
      for (let i = 0; i < this.batchForms.length; i++) {
        const form = this.batchForms[i]
        if (form.advertiser_id && form.adgroup_ids && form.adgroup_ids.length > 0) {
          configuredForms.push({ form, index: i })
        }
      }

      if (configuredForms.length === 0) {
        this.$message.warning('没有可用的窗口（需要先选择广告主和广告组）')
        return
      }

      // 使用与 autoAllocateVideos 相同的逻辑进行分配
      this.allocateVideosFromServerMaterials(videos, configuredForms)
    },

    allocateVideosFromServerMaterials(selectedVideos, configuredForms) {
      // 计算需要的视频总数
      const totalVideosNeeded = configuredForms.reduce((sum, { form }) => {
        return sum + ((form.adCount || 1) * (form.videosPerAd || 1))
      }, 0)

      // 检查视频数量是否足够
      if (selectedVideos.length < totalVideosNeeded) {
        this.$message.error(`视频数量不足！需要 ${totalVideosNeeded} 个，已选择 ${selectedVideos.length} 个`)
        return
      }

      // 调用统一的分配方法（与 autoAllocateVideos 完全相同的逻辑）
      this.allocateVideosToForms(selectedVideos.slice(0, totalVideosNeeded), configuredForms)

      // 展开所有折叠面板
      this.activeCollapseNames = Array.from({ length: this.batchForms.length }, (_, i) => i)
    },
    showServerMaterials() {
      // if (!this.filter.advertiser_id) {
      //   this.$message.warning('请先选择广告主')
      //   return
      // }

      // 确保广告组列表已加载
      // if (!this.adgroupOptions || this.adgroupOptions.length === 0) {
      //   this.$message.warning('请先加载广告组列表')
      //   return
      // }

      console.log('打开素材查询抽屉，广告主:', this.filter.advertiser_id)
      console.log('广告组列表:', this.adgroupOptions)

      this.serverMaterialsDrawerVisible = true
    },

    cleanExtraCovers() {
      if (!this.globalVideoLibrary || this.globalVideoLibrary.length === 0) {
        this.$message.warning('素材库为空')
        return
      }

      let cleanedCount = 0
      let totalProcessed = 0

      this.globalVideoLibrary.forEach(video => {
        if (video.creative_info && video.creative_info.image_info) {
          totalProcessed++
          const originalLength = video.creative_info.image_info.length

          if (originalLength > 1) {
            video.creative_info.image_info = [video.creative_info.image_info[0]]
            cleanedCount++
          }
        }
      })

      if (cleanedCount > 0) {
        this.saveVideoLibraryToCache()
        this.$message.success(`清理完成！共处理 ${totalProcessed} 个视频，清理了 ${cleanedCount} 个视频的多余封面`)
      } else {
        this.$message.info(`无需清理，所有视频都只有 0 或 1 个封面（共 ${totalProcessed} 个视频）`)
      }
    },
    handleFormAdCountChange(formIndex) {
      const form = this.batchForms[formIndex]
      console.log(`[窗口 ${formIndex + 1}] 广告数量变更为:`, form.adCount)
      this.updateAllocationSummary()
    },

    getRecommendedVideosPerAd(form) {
      if (!form || !this.globalVideoLibrary) {
        return 0
      }

      // 计算全局选中视频总数
      const totalSelectedVideos = this.globalVideoLibrary.filter(v => v.selected).length

      if (totalSelectedVideos === 0) {
        return 0
      }

      // 计算所有窗口的总广告数
      const totalAdsNeeded = this.batchForms.reduce((sum, f) => {
        return sum + (f.adCount || 1)
      }, 0)

      if (totalAdsNeeded === 0) {
        return 0
      }

      // 全局平均：总选中视频数 / 总广告数
      const recommended = Math.floor(totalSelectedVideos / totalAdsNeeded)

      // 至少返回1，最多返回20
      return Math.min(Math.max(recommended, 1), 20)
    },

    // ========== 新建广告组相关方法 ==========

    openCreateAdgroupDialog(formIndex) {
      const form = this.batchForms[formIndex]

      if (!form.advertiser_id) {
        this.$message.warning('请先选择广告主')
        return
      }

      this.currentAdgroupFormIndex = formIndex
      this.createAdgroupFormData.advertiser_id = form.advertiser_id

      // 设置默认开始时间为当前时间
      const now = new Date()
      this.createAdgroupFormData.schedule_start_time = this.formatDateTime(now)

      this.createAdgroupDialogVisible = true

      // 加载小游戏列表
      this.loadMinisOptions()

      // 加载地理位置列表
      this.loadLocationOptions()
    },

    handleCreateAdgroupDialogClose() {
      this.currentAdgroupFormIndex = null
      this.createAdgroupFormData = {
        advertiser_id: '',
        count: 1,
        objective_type: 'APP_PROMOTION',
        budget_mode: 'BUDGET_MODE_DYNAMIC_DAILY_BUDGET',
        budget: 50,
        promotion_type: 'MINI_GAME',
        minis_id: '',
        optimization_goal: 'CONVERT',
        optimization_event: 'PURCHASE',
        bid_type: 'BID_TYPE_NO_BID',
        conversion_bid_price: 100,
        bid_price: 100,
        deep_bid_type: '',
        roas_bid: null,
        schedule_type: 'SCHEDULE_FROM_NOW',
        schedule_start_time: '',
        schedule_end_time: '',
        placement_type: 'PLACEMENT_TYPE_AUTOMATIC',
        placements: [],
        targeting_location_ids: ['6252001'],
        targeting_languages: ['en']
      }
      if (this.$refs.createAdgroupForm) {
        this.$refs.createAdgroupForm.clearValidate()
      }
    },

    async loadMinisOptions() {
      try {
        this.minisLoading = true
        const advertiserId = this.createAdgroupFormData.advertiser_id || this.filter.advertiser_id

        if (!advertiserId) {
          this.$message.warning('请先选择广告主')
          return
        }

        // TODO: 这里需要调用获取小游戏列表的API
        // 暂时使用模拟数据
        const res = await catalogApi.getMinisList({
          advertiserId,
          page: 1,
          pageSize: 50
        })

        if (res.code === 0) {
          this.minisOptions = res.data.list || []
        }
      } catch (error) {
        console.error('获取小游戏列表失败', error)
        this.$message.error('获取小游戏列表失败')
      } finally {
        this.minisLoading = false
      }
    }, async loadLocationOptions() {
      try {
        this.locationLoading = true

        // 这里需要调用获取地理位置列表的API
        // 如果后端没有提供，可以使用静态数据或从 adgroupsIndex.vue 复制逻辑
        const defaultLocations = [
          { id: '6252001', name: '美国' },
          { id: '6089730', name: '印度尼西亚' },
          { id: '6089729', name: '日本' },
          { id: '6089731', name: '韩国' },
          { id: '6089732', name: '泰国' },
          { id: '6089733', name: '越南' },
          { id: '6089734', name: '菲律宾' },
          { id: '6089735', name: '马来西亚' },
          { id: '6089736', name: '新加坡' },
          { id: '6089737', name: '台湾' },
          { id: '6089738', name: '香港' }
        ]

        this.locationOptions = defaultLocations
      } catch (error) {
        console.error('获取地理位置列表失败', error)
      } finally {
        this.locationLoading = false
      }
    },

    async handleBatchCreateAdgroups() {
      try {
        await this.$refs.createAdgroupForm.validate()

        this.createAdgroupLoading = true

        const formIndex = this.currentAdgroupFormIndex
        const form = this.batchForms[formIndex]
        const advertiserId = form.advertiser_id

        let successCount = 0
        let failCount = 0
        const errors = []
        const createdAdgroupIds = []

        this.$message.info(`正在创建 ${this.createAdgroupFormData.count} 个广告系列和广告组...`)

        for (let i = 0; i < this.createAdgroupFormData.count; i++) {
          const timestamp = Date.now()

          const now = new Date()
          const year = now.getFullYear()
          const month = String(now.getMonth() + 1).padStart(2, '0')
          const day = String(now.getDate()).padStart(2, '0')
          const hours = String(now.getHours()).padStart(2, '0')
          const minutes = String(now.getMinutes()).padStart(2, '0')
          const seconds = String(now.getSeconds()).padStart(2, '0')
          const dateTimeStr = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

          const username = this.$store.state.username || 'unkown'

          const baseName = form.ad_name || '广告'

          const campaignName = `${baseName}_${username}_${dateTimeStr}_广告系列_${i + 1}`
          const adgroupName = `${baseName}_${username}_${dateTimeStr}_广告组_${i + 1}`

          let campaignId = ''

          try {



            const campaignRequestData = {
              advertiser_id: advertiserId,
              campaign_name: campaignName,
              objective_type: this.createAdgroupFormData.objective_type,
              campaign_type: 'REGULAR_CAMPAIGN',
              budget_optimize_on: true,
              budget_mode: this.createAdgroupFormData.budget_mode,
              budget: this.createAdgroupFormData.budget ,
              request_id: `${timestamp}${i}`,
              app_promotion_type:"MINIS"
            }

            const campaignRes = await campaignApi.create(campaignRequestData)

            if (campaignRes.code === 0 && campaignRes.data && campaignRes.data.campaign_id) {
              campaignId = campaignRes.data.campaign_id
              console.log(`成功创建广告系列 ${i + 1}:`, campaignId)
            } else {
              throw new Error(campaignRes.message || '创建广告系列失败')
            }
          } catch (error) {
            failCount++
            errors.push(`第${i + 1}个广告系列：${error.message || '创建失败'}`)
            continue
          }
          const adjustedStartTime = this.addHoursToDate(this.createAdgroupFormData.schedule_start_time, 5)

          const adgroupRequestData = {
            advertiser_id: advertiserId,
            adgroup_name: adgroupName,
            campaign_id: campaignId,
            promotion_type: this.createAdgroupFormData.promotion_type,
            minis_id: this.createAdgroupFormData.minis_id,
            optimization_goal: this.createAdgroupFormData.optimization_goal,
            bid_type: this.createAdgroupFormData.bid_type,
            schedule_type: this.createAdgroupFormData.schedule_type,
            schedule_start_time: adjustedStartTime,
            placement_type: this.createAdgroupFormData.placement_type,
            optimization_event: this.formData.optimization_event || 'AD_REVENUE_VALUE',
            billing_event: 'OCPM',
            vbo_window:'ZERO_DAY',
            request_id: `${timestamp}${i}`+1
          }



          if (this.createAdgroupFormData.bid_type === 'BID_TYPE_CUSTOM') {
            adgroupRequestData.conversion_bid_price = this.createAdgroupFormData.conversion_bid_price
            adgroupRequestData.bid_price = this.createAdgroupFormData.bid_price
          }

          if (this.createAdgroupFormData.optimization_goal === 'VALUE') {
            if (this.createAdgroupFormData.deep_bid_type) {
              adgroupRequestData.deep_bid_type = this.createAdgroupFormData.deep_bid_type
            }
            if (this.createAdgroupFormData.roas_bid) {
              adgroupRequestData.roas_bid = this.createAdgroupFormData.roas_bid
            }
          }

          if (this.createAdgroupFormData.schedule_type === 'SCHEDULE_START_END') {
            adgroupRequestData.schedule_end_time = this.createAdgroupFormData.schedule_end_time
          }

          if (this.createAdgroupFormData.placement_type === 'PLACEMENT_TYPE_NORMAL') {
            adgroupRequestData.placements = this.createAdgroupFormData.placements
          }
          // 定向设置
          if ((this.createAdgroupFormData.targeting_location_ids &&
              this.createAdgroupFormData.targeting_location_ids.length > 0) ||
              this.createAdgroupFormData.targeting_gender) {
            adgroupRequestData.targeting_spec = {
              location_ids: this.createAdgroupFormData.targeting_location_ids || [],
              languages: this.createAdgroupFormData.targeting_languages || []
            }
            // 添加性别定向
            if (this.createAdgroupFormData.targeting_gender && this.createAdgroupFormData.targeting_gender !== 'GENDER_UNLIMITED') {
              adgroupRequestData.targeting_spec.gender = this.createAdgroupFormData.targeting_gender
            }
          }
          try {
            const adgroupRes = await adgroupApi.create(adgroupRequestData)
            if (adgroupRes.code === 0) {
              successCount++
              if (adgroupRes.data && adgroupRes.data.adgroup_id) {
                createdAdgroupIds.push(adgroupRes.data.adgroup_id)
              }
            } else {
              failCount++
              errors.push(`第${i + 1}个广告组：${adgroupRes.message || '创建失败'}`)
            }
          } catch (error) {
            failCount++
            errors.push(`第${i + 1}个广告组：${error.message || '创建失败'}`)
          }
        }

        if (successCount > 0) {
          form.adgroup_ids = [...form.adgroup_ids, ...createdAdgroupIds]

          await this.loadAdgroupOptionsForForm(formIndex, advertiserId)
          // 将新创建的广告组ID添加到当前窗口的选择中
          form.adgroup_ids = [...form.adgroup_ids, ...createdAdgroupIds]

          this.$message.success(`成功创建 ${successCount} 个广告系列和广告组${failCount > 0 ? `，${failCount} 个失败` : ''}`)

          if (failCount > 0 && errors.length > 0) {
            console.error('创建失败的项目：', errors)
          }

          this.createAdgroupDialogVisible = false
        } else {
          this.$message.error('创建全部失败：' + errors.join('; '))
        }
      } catch (err) {
        if (err !== 'cancel') {
          this.$message.error(err.message || '操作失败')
        }
      } finally {
        this.createAdgroupLoading = false
      }
    },
    addHoursToDate(dateString, hours) {
      if (!dateString) return dateString

      const date = new Date(dateString)
      date.setHours(date.getHours() + hours)

      return this.formatDateTime(date)
    },

    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    applyRecommendedVideosPerAd(formIndex) {
      const form = this.batchForms[formIndex]
      const recommended = this.getRecommendedVideosPerAd(form)

      if (recommended > 0) {
        form.videosPerAd = recommended
        this.$message.success(`已应用推荐值：每广告 ${recommended} 个视频`)
        this.handleFormAdCountChange(formIndex)
      }
    },
    loadVideoLibraryFromCache() {
      try {
        const cached = localStorage.getItem(this.VIDEO_LIBRARY_STORAGE_KEY)
        if (cached) {
          const parsed = JSON.parse(cached)
          if (Array.isArray(parsed)) {
            this.globalVideoLibrary = parsed
            console.log(`从缓存加载了 ${parsed.length} 个视频`, parsed)

            this.cleanExtraCovers()
          }
        }
      } catch (error) {
        console.error('加载视频素材库缓存失败', error)
        this.globalVideoLibrary = []
      }
    },

    saveVideoLibraryToCache() {
      try {
        const videosToSave = this.globalVideoLibrary.map(video => ({
          creative_info: video.creative_info,
          selected: video.selected || false,
          file_name: video.file_name || ''
        }))
        localStorage.setItem(this.VIDEO_LIBRARY_STORAGE_KEY, JSON.stringify(videosToSave))
        console.log(`已保存 ${videosToSave.length} 个视频到缓存`)
      } catch (error) {
        console.error('保存视频素材库缓存失败', error)
        if (error.name === 'QuotaExceededError') {
          this.$message.warning('缓存空间不足，部分视频可能无法保存')
        }
      }
    },
    handleFormAdgroupChange(formIndex) {
      const form = this.batchForms[formIndex]
      console.log(`[窗口 ${formIndex + 1}] 广告组变更为:`, form.adgroup_ids)
      this.updateAllocationSummary()
    },

    applyRecommendedToAllWindows() {
      let appliedCount = 0

      this.batchForms.forEach((form, index) => {
        const recommended = this.getRecommendedVideosPerAd(form)
        if (recommended > 0) {
          form.videosPerAd = recommended
          appliedCount++
        }
      })

      if (appliedCount > 0) {
        this.$message.success(`已为 ${appliedCount} 个窗口应用推荐值`)
        this.updateAllocationSummary()
      } else {
        this.$message.warning('没有可应用推荐值的窗口（需要先选择视频）')
      }
    },

    getTotalSelectedVideos() {
      if (!this.globalVideoLibrary) return 0
      return this.globalVideoLibrary.filter(v => v.selected).length
    },

    getTotalAdsNeeded() {
      if (!this.batchForms) return 0
      return this.batchForms.reduce((sum, form) => {
        return sum + (form.adCount || 1)
      }, 0)
    },
    getSelectedVideosCount() {
      if (!this.globalVideoLibrary) return 0
      return this.globalVideoLibrary.filter(v => v.selected).length
    },

    isAllSelected() {
      if (!this.globalVideoLibrary || this.globalVideoLibrary.length === 0) {
        return false
      }
      return this.globalVideoLibrary.every(video => video.selected)
    },

    toggleSelectAll() {
      const shouldSelect = !this.isAllSelected()
      this.globalVideoLibrary.forEach(video => {
        video.selected = shouldSelect
      })

      if (shouldSelect) {
        this.$message.success(`已全选 ${this.globalVideoLibrary.length} 个视频`)
      } else {
        this.$message.info('已取消全选')
      }

      this.updateAllocationSummary()
    },
    updateAllocationSummary() {
      if (!this.batchForms || !this.globalVideoLibrary) {
        return
      }

      const totalAdsNeeded = this.batchForms.reduce((sum, form) => {
        return sum + (form.adCount || 1)
      }, 0)

      const totalVideosNeeded = this.batchForms.reduce((sum, form) => {
        return sum + ((form.adCount || 1) * (form.videosPerAd || 1))
      }, 0)

      const selectedVideos = this.globalVideoLibrary.filter(v => v.selected).length
      const configuredForms = this.batchForms.filter(f => f.advertiser_id && f.adgroup_ids && f.adgroup_ids.length > 0)

      if (configuredForms.length === 0) {
        this.allocationSummary = {
          show: true,
          title: '请先配置窗口',
          message: '需要为各个窗口选择广告主和广告组',
          type: 'warning'
        }
        return
      }

      let summaryHtml = `<strong>${configuredForms.length}</strong> 个已配置窗口，共需创建 <strong>${totalAdsNeeded}</strong> 个广告<br/>`
      summaryHtml += `需要 <strong>${totalVideosNeeded}</strong> 个视频（每个广告 ${this.batchForms[0]?.videosPerAd || 1} 个）<br/>`

      if (selectedVideos === 0) {
        summaryHtml += `请在上方素材库中勾选要使用的视频`
        this.allocationSummary = {
          show: true,
          title: '请先选择视频',
          message: summaryHtml,
          type: 'warning'
        }
      } else if (selectedVideos < totalVideosNeeded) {
        summaryHtml += `已选择 <strong>${selectedVideos}</strong> 个视频，还差 <strong>${totalVideosNeeded - selectedVideos}</strong> 个`
        this.allocationSummary = {
          show: true,
          title: '视频数量不足',
          message: summaryHtml,
          type: 'warning'
        }
      } else {
        summaryHtml += `已选择 <strong>${selectedVideos}</strong> 个视频可用`
        this.allocationSummary = {
          show: true,
          title: '分配方案就绪',
          message: summaryHtml,
          type: 'success'
        }
      }
    },
    get canAllocate() {
      if (!this.batchForms || !this.globalVideoLibrary) {
        return false
      }

      const configuredForms = this.batchForms.filter(f =>
          f.advertiser_id && f.adgroup_ids && f.adgroup_ids.length > 0
      )
      const selectedVideos = this.globalVideoLibrary.filter(v => v.selected).length
      return configuredForms.length > 0 && selectedVideos > 0
    },


    async handleGlobalVideoUpload(options) {
      const { file } = options

      const isMP4 = file.type === 'video/mp4' || file.type === 'video/quicktime'
      const isLt500M = file.size / 1024 / 1024 < 500

      if (!isMP4) {
        this.$message.error(`文件 "${file.name}" 格式不正确,只能上传 MP4 或 MOV 格式`)
        return
      }
      if (!isLt500M) {
        this.$message.error(`文件 "${file.name}" 大小超过 500MB`)
        return
      }

      const advertiserId = '7598883753192357896'
      if (!advertiserId) {
        this.$message.error('请先在筛选栏选择广告主')
        return
      }

      if (!this.globalUploading) {
        this.globalUploading = true
        this.globalUploadingCount = 0
        this.globalTotalCount = 1
        this.currentBatchFiles = [file]
        this.processUploadQueue2(advertiserId)
      } else {
        this.globalTotalCount++
        this.currentBatchFiles.push(file)
      }
    },

    async processUploadQueue2(advertiserId) {
      const UPLOAD_INTERVAL = 2000

      while (this.currentBatchFiles.length > 0) {
        const file = this.currentBatchFiles.shift()
        const currentFileIndex = this.globalUploadingCount + 1
        const totalFiles = this.globalTotalCount

        try {
          await this.uploadSingleVideoToLibrary(file, advertiserId)

          this.globalUploadingCount++

          if (currentFileIndex < totalFiles) {
            this.$message.success(`视频上传成功 (${currentFileIndex}/${totalFiles})`)
          }
        } catch (error) {
          console.error('视频上传失败', error)

          this.globalUploadingCount++

          if (error.message && error.message.includes('已存在')) {
            if (currentFileIndex < totalFiles) {
              this.$message.info(`视频 "${file.name}" 已存在，已自动添加到素材库 (${currentFileIndex}/${totalFiles})`)
            }
          } else {
            this.$message.error(`视频 "${file.name}" 上传失败: ${error.message} (${currentFileIndex}/${totalFiles})`)
          }
        }

        if (this.currentBatchFiles.length > 0) {
          await new Promise(resolve => setTimeout(resolve, UPLOAD_INTERVAL))
        }
      }

      setTimeout(() => {
        this.globalUploading = false
        this.globalUploadingCount = 0
        this.globalTotalCount = 0
        this.currentBatchFiles = []
        this.$message.success(`批量上传完成！素材库共有 ${this.globalVideoLibrary.length} 个视频`)
      }, 500)
    },
    // async uploadSingleVideoToLibrary(file, advertiserId) {
    //   // 使用原始文件名
    //   const originalFileName = file.name
    //
    //   // 先检查本地缓存中是否已存在相同文件名的视频
    //   const existingVideo = this.findDuplicateVideo(originalFileName)
    //   if (existingVideo) {
    //     console.log(`文件 "${originalFileName}" 已存在于本地素材库中，跳过上传`)
    //     // 不抛出异常，直接返回已存在的视频
    //     return existingVideo
    //   }
    //
    //   const uploadFormData = new FormData()
    //   uploadFormData.append('advertiser_id', advertiserId)
    //   uploadFormData.append('video_file', file)
    //   uploadFormData.append('file_name', originalFileName)
    //   uploadFormData.append('flaw_detect', true)
    //   uploadFormData.append('auto_fix_enabled', true)
    //   uploadFormData.append('auto_bind_enabled', true)
    //
    //   // 上传视频
    //   const res = await videoApi.uploadByFile(uploadFormData)
    //
    //   if (res.code === 200 && res.data) {
    //     const newCreative = {
    //       creative_info: {
    //         ad_format: 'SINGLE_VIDEO',
    //         video_info: {
    //           video_id: res.data.video_id,
    //           video_cover_url: res.data.video_cover_url,
    //           preview_url: res.data.preview_url
    //         },
    //         image_info: [],
    //         identity_type: "BC_AUTH_TT",
    //         identity_id: "1d955ad7-cceb-539d-97e5-875db5b789f9",
    //         identity_authorized_bc_id: "7596985632614989825"
    //       },
    //       selected: false,
    //       file_name: originalFileName
    //     }
    //
    //     if (res.data.video_cover_url) {
    //       await this.uploadGlobalVideoCover(newCreative, res.data.video_cover_url, advertiserId)
    //     }
    //
    //
    //     if(res.data.preview_url!=null){
    //       this.globalVideoLibrary.push(newCreative)
    //       // 保存到缓存
    //       this.saveVideoLibraryToCache()
    //
    //     }else{
    //       throw new Error('视频上传失败：未获取到预览地址(preview_url)')
    //     }
    //
    //     return newCreative
    //   } else if (res.code === 40911) {
    //     // 文件名重复，尝试从服务器查询已有视频
    //     console.log(`检测到重复文件名 "${originalFileName}"，正在查询已有视频...`)
    //     const existingVideo = await this.fetchExistingVideoByName(advertiserId, originalFileName)
    //
    //     if (existingVideo) {
    //
    //         console.log('找到已有视频，添加到素材库', existingVideo)
    //         this.globalVideoLibrary.push(existingVideo)
    //         this.saveVideoLibraryToCache()
    //
    //     } else {
    //       throw new Error(`文件 "${originalFileName}" 已存在，但无法获取视频信息`)
    //     }
    //   } else {
    //     throw new Error(res.message || '视频上传失败')
    //   }
    // },

    async fetchExistingVideoByName(advertiserId, fileName) {
      try {
        const res = await videoApi.search({
          advertiserId,
          videoName: fileName,
          page: 1,
          pageSize: 20
        })

        if (res.code === 200 && res.data && res.data.length > 0) {
          // 取第一个匹配的视频
          const videoData = res.data[0]

          // 转换为素材库格式
          const existingCreative = {
            creative_info: {
              ad_format: 'SINGLE_VIDEO',
              video_info: {
                video_id: videoData.video_id,
                video_cover_url: videoData.video_cover_url,
                preview_url: videoData.preview_url
              },
              image_info: [],
              identity_type: "BC_AUTH_TT",
              identity_id: "1d955ad7-cceb-539d-97e5-875db5b789f9",
              identity_authorized_bc_id: "7596985632614989825"
            },
            selected: false,
            file_name: videoData.file_name || fileName
          }

          // 如果有封面URL，尝试上传封面图片
          if (videoData.video_cover_url) {
            await this.uploadGlobalVideoCover(existingCreative, videoData.video_cover_url, advertiserId)
          }

          return existingCreative
        } else {
          console.warn(`未找到文件名为 "${fileName}" 的视频`)
          return null
        }
      } catch (error) {
        console.error('查询已有视频失败', error)
        return null
      }
    },
    findDuplicateVideo(fileName) {
      if (!this.globalVideoLibrary || this.globalVideoLibrary.length === 0) {
        return null
      }

      // 查找是否有相同文件名的视频
      return this.globalVideoLibrary.find(video => {
        const videoFileName = video.file_name || ''
        return videoFileName === fileName
      })
    },

    async uploadGlobalVideoCover(creative, coverUrl, advertiserId) {
      try {
        const timestamp = Date.now()
        const generatedFileName = `cover_${timestamp}_${Math.random().toString(36).substring(7)}.jpg`

        const res = await imageApi.uploadByUrl({
          advertiserId,
          imageUrl: coverUrl,
          fileName: generatedFileName
        })

        if (res.code === 200 && res.data?.image_id) {
          creative.creative_info.image_info.push({
            web_uri: res.data.image_id
          })
        }

        await new Promise(resolve => setTimeout(resolve, 500))
      } catch (error) {
        console.error('上传视频封面失败', error)
        if (error.message && error.message.toLowerCase().includes('too many requests')) {
          console.warn('检测到频率限制，等待2秒后重试...')
          await new Promise(resolve => setTimeout(resolve, 2000))
          try {
            const timestamp = Date.now()
            const generatedFileName = `cover_${timestamp}_${Math.random().toString(36).substring(7)}.jpg`

            const retryRes = await imageApi.uploadByUrl({
              advertiserId,
              imageUrl: coverUrl,
              fileName: generatedFileName
            })

            if (retryRes.code === 200 && retryRes.data?.image_id) {
              creative.creative_info.image_info.push({
                web_uri: retryRes.data.image_id
              })
            }
          } catch (retryError) {
            console.error('重试上传封面仍然失败', retryError)
          }
        }
      }
    },

    removeFromGlobalLibrary(index) {
      this.$confirm('确定要从素材库删除这个视频吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.globalVideoLibrary.splice(index, 1)
        this.saveVideoLibraryToCache()
        this.$message.success('已从素材库删除')
      }).catch(() => {})
    },

    clearGlobalLibrary() {
      this.$confirm('确定要清空所有视频素材吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.globalVideoLibrary = []
        localStorage.removeItem(this.VIDEO_LIBRARY_STORAGE_KEY)
        this.$message.success('素材库已清空')
      }).catch(() => {})
    }, hasVideoCover(video) {
      if (!video || !video.creative_info || !video.creative_info.image_info) {
        return false
      }
      return video.creative_info.image_info.length > 0 &&
          video.creative_info.image_info.some(img => img.web_uri)
    },

    async reuploadVideoCover(videoIndex) {
      const video = this.globalVideoLibrary[videoIndex]
      if (!video) {
        this.$message.error('视频不存在')
        return
      }

      const coverUrl = video.creative_info?.video_info?.video_cover_url
      if (!coverUrl) {
        this.$message.error('该视频没有封面URL，无法重新上传')
        return
      }

      const advertiserId = this.filter.advertiser_id
      if (!advertiserId) {
        this.$message.error('请先选择广告主')
        return
      }

      try {
        this.$message.info('正在重新上传封面...')

        await this.uploadGlobalVideoCover(video, coverUrl, advertiserId)

        if (this.hasVideoCover(video)) {
          this.saveVideoLibraryToCache()
          this.$message.success('封面上传成功')
        } else {
          this.$message.warning('封面上传完成，但未获取到有效的图片ID')
        }
      } catch (error) {
        console.error('重新上传封面失败', error)
        this.$message.error('重新上传封面失败：' + (error.message || '未知错误'))
      }
    },

    handleAllocationConfigChange() {
      this.calculateAllocationResult()
    },

    calculateAllocationResult() {
      const adgroupCount = this.allocationConfig.adgroupIds.length
      const videosPerAd = this.allocationConfig.videosPerAd
      const totalVideosNeeded = adgroupCount * videosPerAd
      const availableVideos = this.globalVideoLibrary.filter(v => v.selected).length

      if (adgroupCount === 0) {
        this.allocationResult = {
          show: false,
          title: '',
          message: '',
          type: 'info'
        }
        return
      }

      let message = ''
      let type = 'info'
      let title = ''

      if (availableVideos === 0) {
        title = '请先选择视频'
        message = `需要为 <strong>${totalVideosNeeded}</strong> 个广告分配视频（${adgroupCount} 个广告组 × ${videosPerAd} 个视频/广告）<br/>请在上方素材库中勾选要使用的视频`
        type = 'warning'
      } else if (availableVideos < totalVideosNeeded) {
        title = '视频数量不足'
        message = `需要 <strong>${totalVideosNeeded}</strong> 个视频，已选择 <strong>${availableVideos}</strong> 个，还差 <strong>${totalVideosNeeded - availableVideos}</strong> 个`
        type = 'warning'
      } else {
        title = '分配方案就绪'
        const distributionMessage = this.getDistributionDescription(adgroupCount, videosPerAd, availableVideos)
        message = `${distributionMessage}<br/>点击「一键分配视频」按钮即可自动分配`
        type = 'success'
      }

      this.allocationResult = {
        show: true,
        title,
        message,
        type
      }
    },

    getDistributionDescription(adgroupCount, videosPerAd, totalSelected) {
      const totalAds = adgroupCount
      const totalVideosNeeded = totalAds * videosPerAd

      return `将为 <strong>${totalAds}</strong> 个广告分配视频<br/>` +
          `每个广告分配 <strong>${videosPerAd}</strong> 个视频<br/>` +
          `共需 <strong>${totalVideosNeeded}</strong> 个视频，已选择 <strong>${totalSelected}</strong> 个可用`
    },

    autoAllocateVideos() {
      const selectedVideos = this.globalVideoLibrary.filter(v => v.selected)

      if (selectedVideos.length === 0) {
        this.$message.warning('请先在素材库中选择视频')
        return
      }

      const configuredForms = []
      for (let i = 0; i < this.batchForms.length; i++) {
        const form = this.batchForms[i]
        if (form.advertiser_id && form.adgroup_ids && form.adgroup_ids.length > 0) {
          configuredForms.push({ form, index: i })
        }
      }

      if (configuredForms.length === 0) {
        this.$message.warning('没有可用的窗口（需要先选择广告主和广告组）')
        return
      }

      const totalVideosNeeded = configuredForms.reduce((sum, { form }) => {
        return sum + ((form.adCount || 1) * (form.videosPerAd || 1))
      }, 0)

      if (selectedVideos.length < totalVideosNeeded) {
        this.$message.error(`视频数量不足！需要 ${totalVideosNeeded} 个，已选择 ${selectedVideos.length} 个`)
        return
      }

      this.allocateVideosToForms(selectedVideos.slice(0, totalVideosNeeded), configuredForms)
    },


    // 分配视频
    allocateVideosToForms(selectedVideos, configuredForms) {

      console.log('分配视频格式:', selectedVideos, configuredForms)
      let videoIndex = 0
      let totalAllocated = 0

      configuredForms.forEach(({ form, index }) => {
        const adCount = form.adCount || 1
        const videosPerAd = form.videosPerAd || 1
        const totalVideosForThisForm = adCount * videosPerAd

        form.allocatedVideos = []

        for (let a = 0; a < adCount; a++) {
          for (let v = 0; v < videosPerAd; v++) {
            if (videoIndex < selectedVideos.length) {
              form.allocatedVideos.push(selectedVideos[videoIndex])
              videoIndex++
            }
          }
        }

        totalAllocated += form.allocatedVideos.length
      })

      this.$message.success(`分配完成！共为 ${configuredForms.length} 个窗口分配了 ${totalAllocated} 个视频`)
      this.updateAllocationSummary()
    },


    async handleBatchFormMultiVideoUpload(options, formIndex) {
      const { file } = options
      const form = this.batchForms[formIndex]

      // 验证文件格式和大小
      const isMP4 = file.type === 'video/mp4' || file.type === 'video/quicktime'
      const isLt500M = file.size / 1024 / 1024 < 500

      if (!isMP4) {
        this.$message.error(`文件 "${file.name}" 格式不正确，只能上传 MP4 或 MOV 格式`)
        return
      }
      if (!isLt500M) {
        this.$message.error(`文件 "${file.name}" 大小超过 500MB`)
        return
      }

      // 检查广告主是否已选择
      const advertiserId = form.advertiser_id || this.filter.advertiser_id
      if (!advertiserId) {
        this.$message.error('请先选择广告主')
        return
      }

      // 将文件添加到上传队列
      if (!form.uploadQueue) {
        this.$set(form, 'uploadQueue', [])
      }

      form.uploadQueue.push({
        file,
        status: 'pending',
        fileName: file.name
      })

      this.$message.success(`已将 "${file.name}" 加入上传队列`)

      // 如果当前没有在上传，开始处理队列
      if (!form.videoUploading) {
        this.processUploadQueue(formIndex)
      }
    },

    async processUploadQueue(formIndex) {
      const form = this.batchForms[formIndex]

      if (!form.uploadQueue || form.uploadQueue.length === 0) {
        console.log(`[窗口 ${formIndex + 1}] 上传队列为空`)
        return
      }

      try {
        form.videoUploading = true
        form.uploadingCount = 0
        form.totalUploadCount = form.uploadQueue.length

        console.log(`[窗口 ${formIndex + 1}] 开始处理上传队列，共 ${form.totalUploadCount} 个视频`)

        // 逐个处理队列中的文件
        while (form.uploadQueue.length > 0) {
          const uploadItem = form.uploadQueue.shift()

          if (!uploadItem) continue

          form.uploadingCount++
          uploadItem.status = 'uploading'

          console.log(`[窗口 ${formIndex + 1}] 正在上传第 ${form.uploadingCount}/${form.totalUploadCount} 个视频: ${uploadItem.fileName}`)
          this.$message.info(`正在上传第 ${form.uploadingCount}/${form.totalUploadCount} 个视频: ${uploadItem.fileName}`)

          try {
            await this.uploadSingleVideo(formIndex, uploadItem.file)
            uploadItem.status = 'success'
            console.log(`[窗口 ${formIndex + 1}] 视频上传成功: ${uploadItem.fileName}`)
          } catch (error) {
            uploadItem.status = 'failed'
            console.error(`[窗口 ${formIndex + 1}] 视频上传失败: ${uploadItem.fileName}`, error)
            this.$message.error(`视频 "${uploadItem.fileName}" 上传失败: ${error.message}`)
          }
        }

        console.log(`[窗口 ${formIndex + 1}] 所有视频上传完成`)
        this.$message.success(`批量上传完成！共上传 ${form.uploadingCount} 个视频`)
      } catch (error) {
        console.error(`[窗口 ${formIndex + 1}] 上传队列处理异常`, error)
        this.$message.error('上传过程发生错误')
      } finally {
        form.videoUploading = false
        form.uploadingCount = 0
        form.totalUploadCount = 0
        form.uploadQueue = []
      }
    },



    async handleBatchFormVideoUpload(file, formIndex) {
      // 保留旧方法作为兼容，但建议使用新的多选上传
      const form = this.batchForms[formIndex]

      const isMP4 = file.type === 'video/mp4' || file.type === 'video/quicktime'
      const isLt500M = file.size / 1024 / 1024 < 500

      if (!isMP4) {
        this.$message.error('只能上传 MP4 或 MOV 格式视频')
        return false
      }
      if (!isLt500M) {
        this.$message.error('视频大小不能超过 500MB')
        return false
      }

      const advertiserId = form.advertiser_id || this.filter.advertiser_id
      if (!advertiserId) {
        this.$message.error('请先选择广告主')
        return false
      }

      form.videoUploading = true
      this.$message.info('正在上传视频，请稍候...')

      try {
        await this.uploadSingleVideo(formIndex, file)
        this.$message.success(`视频上传成功（共${form.creativeList.length}个）`)
      } catch (error) {
        console.error('视频上传失败', error)
        this.$message.error(error.message || '视频上传失败')
        return false
      } finally {
        form.videoUploading = false
      }

      return false
    },

    async initData() {
      // 按顺序加载数据：广告主 → 广告组 → 广告
      await this.fetchAdvertisers()
      // if(this.filter.advertiser_id){
      //   await this.fetchAdgroupOptions()
      //   await this.fetchAds()
      // }

    },

    loadAdvertiserSelection() {
      // 从本地加载上次选择的广告主
      const savedAdvertiserId = localStorage.getItem(this.ADVERTISER_STORAGE_KEY)
      if (savedAdvertiserId) {
        this.filter.advertiser_id = savedAdvertiserId
      }
    },

    saveAdvertiserSelection(advertiserId) {
      // 保存广告主选择到本地
      if (advertiserId) {
        localStorage.setItem(this.ADVERTISER_STORAGE_KEY, advertiserId)
      } else {
        localStorage.removeItem(this.ADVERTISER_STORAGE_KEY)
      }
    },
    async fetchAdvertisers() {
      try {
        const res = await advertiserApi.getList({
          page: 1,
          pageSize: 100
        })
        if (res.code === 0) {
          this.advertisers = res.data.list || []
        }
      } catch (error) {
        console.error('获取广告主列表失败', error)
      }
    },


    handleAdvertiserChange() {
      // 保存广告主选择到本地
      this.saveAdvertiserSelection(this.filter.advertiser_id)

      // 切换广告主时重置相关筛选条件
      this.filter.adgroup_id = ''
      this.pagination.page = 1
      this.fetchAdgroupOptions()
      this.fetchAds()
    },
    getVideoUrl(creative) {
      // 安全获取视频URL
      if (!creative || !creative.creative_info) return ''
      const videoInfo = creative.creative_info.video_info || {}
      return videoInfo.preview_url || videoInfo.video_url || ''
    },

    getVideoId(creative) {
      // 安全获取视频ID
      if (!creative || !creative.creative_info) return ''
      const videoInfo = creative.creative_info.video_info || {}
      return videoInfo.video_id || ''
    },

    getVideoFileName(video) {
      // 获取视频文件名
      if (!video) return ''
      return video.file_name || '未命名视频'
    },

    hasCoverImage(creative) {
      // 检查是否有封面图片
      if (!creative || !creative.creative_info) return false
      return true
    },

    getCoverUrl(webUri) {
      // 根据 web_uri 构建完整的封面URL
      if (!webUri) return ''
      // 如果已经是完整URL，直接返回
      if (webUri.startsWith('http')) return webUri
      // 否则构建TikTok CDN URL
      return `https://p16-ad-site-sign-sg.ibyteimg.com/${webUri}~tplv-d5opwmad15-image.jpeg`
    },
    getRowKey(row) {
      return row.smart_plus_ad_id || row.id || Math.random()
    },

    initFields() {
      this.allFields = AD_FIELDS.map(field => ({
        ...field,
        label: AD_FIELD_LABEL[field.key] || field.label,
        width: this.getFieldWidth(field.key),
        minWidth: this.getFieldMinWidth(field.key)
      }))
      this.defaultFields = this.allFields.filter(f => f.default).map(f => f.key)
    },

    getFieldWidth(key) {
      const widthMap = {
        smart_plus_ad_id: 180,
        ad_name: 200,
        ad_format: 100,
        creative_preview: 100,
        review_status: 100,
        operation_status: 100,
        create_time: 160,
        modify_time: 160
      }
      return widthMap[key] || null
    },

    getFieldMinWidth(key) {
      const minWidthMap = {
        ad_name: 180
      }
      return minWidthMap[key] || null
    },

    loadSelectedFields() {
      const saved = localStorage.getItem(this.STORAGE_KEY)
      if (saved) {
        try {
          const parsed = JSON.parse(saved)
          const validFields = parsed.filter(key => this.allFields.some(f => f.key === key))
          this.selectedFields = [...new Set([...this.defaultFields, ...validFields])]
        } catch (e) {
          this.selectedFields = [...this.defaultFields]
        }
      } else {
        this.selectedFields = [...this.defaultFields]
      }
    },

    saveSelectedFields() {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.selectedFields))
    },

    handleFieldsConfirm(selectedFields) {
      this.selectedFields = selectedFields
      this.saveSelectedFields()
      this.tableKey++
    },

    formatFieldValue(value) {
      if (value === null || value === undefined) return '-'
      if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : '-'
      if (typeof value === 'object') return JSON.stringify(value)
      if (typeof value === 'boolean') return value ? '是' : '否'
      return String(value)
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },

    async fetchAdgroupOptions() {
      try {
        const advertiserId = this.filter.advertiser_id
        const res = await adgroupApi.getList({
          advertiserId,
          page: 1,
          pageSize: 100
        })
        if (res.code === 0) {
          this.adgroupOptions = res.data.list || []
        }
      } catch (error) {
        console.error('获取广告组列表失败', error)
      }
    },

    async fetchAds() {
      this.loading = true
      try {
        const advertiserId = this.filter.advertiser_id

        this.fetchAdgroupOptions()

        const params = {
          advertiserId,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          adName: this.filter.ad_name,
          adgroupId: this.filter.adgroup_id || this.routeQueryAdgroupId,
          adFormat: this.filter.ad_format,
          operationStatus: this.filter.operation_status
        }

        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0]
          params.endDate = this.dateRange[1]
        }

        const res = await adApi.getList(params)

        if (res.code === 0) {
          this.ads = res.data.list || []
          this.pagination.total = res.data.page_info?.total_number || 0

          await this.fetchAllReviewStatusConcurrently(this.ads)
        }
      } catch (error) {
        console.error('获取列表失败', error)
        this.$message.error(error.message || '获取列表失败')
      } finally {
        this.loading = false
      }
    },

    async fetchAllReviewStatusConcurrently(ads) {
      const BATCH_SIZE = 5
      for (let i = 0; i < ads.length; i += BATCH_SIZE) {
        const batch = ads.slice(i, i + BATCH_SIZE)
        const promises = batch.map(ad => this.fetchAdReviewStatus(ad))
        await Promise.all(promises)
      }
    },

    async fetchAdReviewStatus(ad) {
      try {
        const advertiserId = this.filter.advertiser_id
        const res = await adApi.getReviewInfo({
          advertiserId,
          smartPlusAdId: ad.smart_plus_ad_id,
          includeRejectInfo: false
        })
        if (res.code === 0 && res.data?.smart_plus_ad_review_infos?.length) {
          ad.review_status = res.data.smart_plus_ad_review_infos[0].review_status
          ad.appeal_status = res.data.smart_plus_ad_review_infos[0].appeal_status
        }
      } catch (error) {
        console.error('获取审核状态失败', error)
      }
    },

    handleSearch() {
      this.pagination.page = 1
      this.fetchAds()
    },

    handleReset() {
      this.filter = {
        ad_name: '',
        adgroup_id: '',
        ad_format: '',
        review_status: '',
        operation_status: ''
      }
      this.dateRange = []
      this.pagination.page = 1
      this.fetchAds()
    },

    handlePageChange(page) {
      this.pagination.page = page
      this.fetchAds()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchAds()
    },

    handleAdFormatChange() {
      const creative = this.formData.creativeList[0]
      if (creative) {
        creative.video_info = {
          video_id: '',
          video_url: '',
          file_name: ''
        }
      }
    }, clearVideo() {
      const creative = this.formData.creativeList[0]
      if (creative) {
        creative.video_info = {
          video_id: '',
          video_url: '',
          file_name: ''
        }
      }
    },

    removeVideo(index) {
      this.$confirm('确定要删除这个视频吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.creativeList.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => {
      })
    },

    async handleVideoUpload(file) {
      const isMP4 = file.type === 'video/mp4' || file.type === 'video/quicktime'
      const isLt500M = file.size / 1024 / 1024 < 500

      if (!isMP4) {
        this.$message.error('只能上传 MP4 或 MOV 格式视频')
        return false
      }
      if (!isLt500M) {
        this.$message.error('视频大小不能超过 500MB')
        return false
      }

      this.videoUploading = true
      this.$message.info('正在上传视频，请稍候...')

      try {
        const advertiserId = this.filter.advertiser_id
        const timestamp = Date.now()  // 13位时间戳
        const fileExtension = file.name.split('.').pop() || 'mp4'  // 获取扩展名
        const generatedFileName = `video_${timestamp}.${fileExtension}`
        const uploadFormData = new FormData()
        uploadFormData.append('advertiser_id', advertiserId)
        uploadFormData.append('video_file', file)
        uploadFormData.append('file_name', generatedFileName)
        uploadFormData.append('flaw_detect', true)
        uploadFormData.append('auto_fix_enabled', true)
        uploadFormData.append('auto_bind_enabled', true)

        const res = await videoApi.uploadByFile(uploadFormData)

        if (res.code === 200 && res.data) {
          // 添加新的视频创意到数组

          const newCreative = {
            creative_info: {
              ad_format: 'SINGLE_VIDEO',
              video_info: {
                video_id: res.data.video_id,
                video_cover_url: res.data.video_cover_url,
                preview_url: res.data.preview_url
              },
              image_info: [],
              identity_type: "BC_AUTH_TT",
              identity_id: "1d955ad7-cceb-539d-97e5-875db5b789f9",
              identity_authorized_bc_id: "7596985632614989825"
            }
          }

          this.formData.creativeList.push(newCreative)

          // 如果有视频封面URL，自动上传封面图片
          if (res.data.video_cover_url) {
            this.uploadVideoCover(newCreative, res.data.video_cover_url)
          }

          this.$message.success(`视频上传成功（共${this.formData.creativeList.length}个）`)
        } else {
          this.$message.error(res.message || '视频上传失败')
          return false
        }
      } catch (error) {
        console.error('视频上传失败', error)
        this.$message.error(error.message || '视频上传失败')
        return false
      } finally {
        this.videoUploading = false
      }

      return false
    },
    async uploadVideoCover(creative, coverUrl) {
      try {
        const advertiserId = this.filter.advertiser_id

        this.$message.info('正在上传视频封面...')
        // 使用时间戳生成封面文件名
        const timestamp = Date.now()
        const generatedFileName = `cover_${timestamp}.jpg`

        const res = await imageApi.uploadByUrl({
          advertiserId,
          imageUrl: coverUrl,
          fileName: generatedFileName
        })

        if (res.code === 200 && res.data?.image_id) {
          // 将 image_id 添加到 image_info 数组中
          creative.creative_info.image_info.push({
            web_uri: res.data.image_id
          })
          this.$message.success('视频封面上传成功')
        } else {
          console.warn('封面上传失败:', res.message)
          this.$message.warning('封面上传失败，但视频已上传成功')
        }
      } catch (error) {
        console.error('上传视频封面失败', error)
        this.$message.warning('封面上传失败：' + (error.message || '未知错误'))
      }
    },


    addAdText() {
      this.formData.ad_text_list.push({ad_text: ''})
    },

    removeAdText(index) {
      this.formData.ad_text_list.splice(index, 1)
    },

    addCta() {
      this.formData.call_to_action_list.push({call_to_action: ''})
    },

    removeCta(index) {
      this.formData.call_to_action_list.splice(index, 1)
    },
    handleCreate() {
      this.isEdit = false
      this.dialogTitle = '批量创建广告'
      this.batchForms = []
      this.activeCollapseNames = []
      this.formData = {
        advertiser_ids: [],
        ad_name: '',
        adgroup_ids: [],
        operation_status: 'ENABLE',
        creativeList: [],
        ad_text_list: [{ad_text: ''}],
        call_to_action_list: [{call_to_action: ''}],
        landing_page_url_list: [{landing_page_url: ''}]
      }
      this.selectedCtaList = []
      this.ctaRecommendList = []
      this.portfolioId = ''
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.adForm && this.$refs.adForm.clearValidate()
      })
      // 打开对话框时获取推荐文案
      this.fetchCtaRecommendations()
      this.addBatchForm()
    },

    // ========== 批量模式方法 ==========

    createEmptyBatchForm() {
      return {
        advertiser_id: '',
        ad_name: '',
        adgroup_ids: [],
        adgroupOptions: [],
        adgroupLoading: false,
        operation_status: 'ENABLE',
        creativeList: [],
        allocatedVideos: [],
        adCount: 1,
        videosPerAd: 1,
        ad_text_list: [{ad_text: ''}],
        selectedCtaList: [],
        landing_page_url_list: [{landing_page_url: ''}],
        videoUploading: false,
        uploadingCount: 0,
        totalUploadCount: 0,
        uploadQueue: []
      }
    },

    addBatchForm() {
      const newForm = this.createEmptyBatchForm()
      this.batchForms.push(newForm)
      // 自动展开新添加的表单
      this.$nextTick(() => {
        this.activeCollapseNames.push(this.batchForms.length - 1)
      })
      this.$message.success('已添加新窗口')
    },

    duplicateLastForm() {
      if (this.batchForms.length === 0) return

      const lastForm = this.batchForms[this.batchForms.length - 1]
      const duplicatedForm = JSON.parse(JSON.stringify(lastForm))
      duplicatedForm.ad_name = duplicatedForm.ad_name ? `${duplicatedForm.ad_name}_副本` : ''
      duplicatedForm.videoUploading = false
      this.batchForms.push(duplicatedForm)

      this.$nextTick(() => {
        this.activeCollapseNames.push(this.batchForms.length - 1)
      })
      this.$message.success('已复制上一个窗口')
    },

    removeBatchForm(index) {
      this.$confirm('确定要删除这个窗口吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchForms.splice(index, 1)
        // 更新展开状态
        this.activeCollapseNames = this.activeCollapseNames
            .map(name => name > index ? name - 1 : name)
            .filter(name => name !== index)
        this.$message.success('已删除窗口')
      }).catch(() => {})
    },

    getAdvertiserName(advertiserId) {
      const advertiser = this.advertisers.find(item => item.advertiser_id === advertiserId)
      return advertiser ? advertiser.advertiser_name : ''
    },

    getAdvertiserTagType(advertiserId) {
      if (!advertiserId) return 'info'
      const types = ['', 'success', 'warning', 'danger', 'info']
      const index = this.batchForms.findIndex(f => f.advertiser_id === advertiserId)
      return types[index % types.length] || 'info'
    },

    handleBatchFormAdvertiserChange(index) {
      const form = this.batchForms[index]

      // 为该窗口加载对应的广告组列表
      if (form.advertiser_id) {
        console.log(`[窗口 ${index + 1}] 广告主变更为: ${form.advertiser_id}，开始加载广告组列表`)

        // 为每个窗口单独存储广告组选项
        if (!form.adgroupOptions) {
          this.$set(form, 'adgroupOptions', [])
        }
        const advertiser = this.advertisers.find(item => item.advertiser_id === form.advertiser_id)
        if (advertiser ) {
          form.ad_name = advertiser.advertiser_name
        }
        this.loadAdgroupOptionsForForm(index, form.advertiser_id)
      } else {
        console.log(`[窗口 ${index + 1}] 清空了广告主选择`)
        this.$set(form, 'adgroupOptions', [])
        form.adgroup_ids = []
      }
    },
    async loadAdgroupOptionsForForm(formIndex, advertiserId) {
      try {
        const form = this.batchForms[formIndex]
        this.$set(form, 'adgroupLoading', true)

        const res = await adgroupApi.getList({
          advertiserId,
          page: 1,
          pageSize: 100
        })

        if (res.code === 0) {
          this.$set(form, 'adgroupOptions', res.data.list || [])
          console.log(`[窗口 ${formIndex + 1}] 广告组加载成功，共 ${form.adgroupOptions.length} 个`)

          // 清空之前选择的广告组（因为广告主变了）
          form.adgroup_ids = []
        } else {
          console.error(`[窗口 ${formIndex + 1}] 广告组加载失败:`, res.message)
          this.$message.error(`窗口 ${formIndex + 1}：加载广告组失败`)
          this.$set(form, 'adgroupOptions', [])
        }
      } catch (error) {
        console.error(`[窗口 ${formIndex + 1}] 获取广告组列表失败`, error)
        this.$message.error(`窗口 ${formIndex + 1}：获取广告组列表失败`)
        this.$set(this.batchForms[formIndex], 'adgroupOptions', [])
      } finally {
        this.$set(this.batchForms[formIndex], 'adgroupLoading', false)
      }
    },

    handleAdgroupDropdownVisibleChange(visible, formIndex) {
      const form = this.batchForms[formIndex]

      // 当下拉框打开时，如果已经选择了广告主，则刷新广告组列表
      if (visible && form.advertiser_id) {
        console.log(`[窗口 ${formIndex + 1}] 广告组下拉框打开，刷新列表`)
        this.loadAdgroupOptionsForForm(formIndex, form.advertiser_id)
      }
    },
    async uploadBatchFormVideoCover(form, creative, coverUrl) {
      try {
        const advertiserId = form.advertiser_id || this.filter.advertiser_id
        if (!advertiserId) return

        this.$message.info('正在上传视频封面...')
        const timestamp = Date.now()
        const generatedFileName = `cover_${timestamp}.jpg`

        const res = await imageApi.uploadByUrl({
          advertiserId,
          imageUrl: coverUrl,
          fileName: generatedFileName
        })

        if (res.code === 200 && res.data?.image_id) {
          creative.creative_info.image_info.push({
            web_uri: res.data.image_id
          })
          this.$message.success('视频封面上传成功')
        }
      } catch (error) {
        console.error('上传视频封面失败', error)
      }
    },

    removeBatchFormVideo(formIndex, creativeIndex) {
      this.$confirm('确定要删除这个视频吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchForms[formIndex].creativeList.splice(creativeIndex, 1)
        this.$message.success('删除成功')
      }).catch(() => {})
    },

    addBatchFormAdText(formIndex) {
      this.batchForms[formIndex].ad_text_list.push({ad_text: ''})
    },

    removeBatchFormAdText(formIndex, textIndex) {
      this.batchForms[formIndex].ad_text_list.splice(textIndex, 1)
    },

    async handleBatchSubmit() {
      if (this.batchForms.length === 0) {
        this.$message.warning('请至少添加一个窗口')
        return
      }

      try {
        this.submitLoading = true

        let hasError = false
        for (let i = 0; i < this.batchForms.length; i++) {
          const form = this.batchForms[i]

          if (!form.advertiser_id) {
            this.$message.error(`窗口 ${i + 1}：请选择广告主`)
            this.activeCollapseNames = [i]
            hasError = true
            break
          }

          if (!form.adgroup_ids || form.adgroup_ids.length === 0) {
            this.$message.error(`窗口 ${i + 1}：请至少选择一个广告组`)
            this.activeCollapseNames = [i]
            hasError = true
            break
          }

          if (!form.allocatedVideos || form.allocatedVideos.length === 0) {
            this.$message.error(`窗口 ${i + 1}：请先在上方分配视频`)
            this.activeCollapseNames = [i]
            hasError = true
            break
          }

          if (hasError) break
        }

        if (hasError) {
          this.submitLoading = false
          return
        }

        const results = {
          successList: [],
          failList: []
        }

        this.$message.info(`开始批量提交 ${this.batchForms.length} 个窗口的广告...`)

        for (let i = 0; i < this.batchForms.length; i++) {
          const form = this.batchForms[i]
          const advertiserId = form.advertiser_id
          const adCount = form.adCount || 1

          this.$message.info(`正在处理窗口 ${i + 1}/${this.batchForms.length}（创建 ${adCount} 个广告）...`)

          let callToActionId = null

          if (form.selectedCtaList && form.selectedCtaList.length > 0) {
            try {
              this.$message.info('正在创建素材包...')
              callToActionId = await this.createPortfolioFromSelectedCta(advertiserId, form.selectedCtaList)
            } catch (error) {
              results.failList.push({
                windowIndex: i + 1,
                adIndex: 0,
                advertiserId,
                error: `创建素材包失败 - ${error.message}`,
                requestData: null,
                canRetry: false
              })
              continue
            }
          }

          const adgroupIds = form.adgroup_ids

          for (let a = 0; a < adCount; a++) {
            const videosPerAd = form.videosPerAd || 1
            const startIndex = a * videosPerAd
            const endIndex = Math.min(startIndex + videosPerAd, form.allocatedVideos.length)
            const videosForThisAd = form.allocatedVideos.slice(startIndex, endIndex)

            if (videosForThisAd.length === 0) {
              results.failList.push({
                windowIndex: i + 1,
                adIndex: a + 1,
                advertiserId,
                error: '没有可分配的视频',
                requestData: null,
                canRetry: false
              })
              continue
            }

            const adgroupId = adgroupIds[a % adgroupIds.length]

            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            const dateTimeStr = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

            const username = this.$store.state.username || 'unknown'
            const baseName = form.ad_name || '广告'
            const adName = `${baseName}_${username}_${dateTimeStr}_${adgroupId}_${a + 1}`

            const requestData = {
              advertiserId,
              adgroup_id: adgroupId,
              ad_name: adName,
              creative_list: videosForThisAd,
              ad_text_list: form.ad_text_list.filter(t => t.ad_text),
              landing_page_url_list: form.landing_page_url_list.filter(item => item.landing_page_url),
              operation_status: form.operation_status || 'ENABLE',
              ad_configuration: {
                dark_post_status: "ON"
              }
            }

            if (callToActionId) {
              requestData.ad_configuration.call_to_action_id = callToActionId
            }

            try {
              const res = await adApi.create(requestData)
              if (res.code === 0) {
                results.successList.push({
                  windowIndex: i + 1,
                  adIndex: a + 1,
                  adName,
                  adId: res.data?.smart_plus_ad_id || '未知',
                  advertiserId
                })
              } else {
                results.failList.push({
                  windowIndex: i + 1,
                  adIndex: a + 1,
                  advertiserId,
                  error: res.message || '创建失败',
                  requestData,
                  canRetry: true
                })
              }
            } catch (error) {
              results.failList.push({
                windowIndex: i + 1,
                adIndex: a + 1,
                advertiserId,
                error: error.message || '创建失败',
                requestData,
                canRetry: true
              })
            }
          }
        }

        this.submitResults = results

        if (results.failList.length > 0) {
          this.submitResultDialogVisible = true
        } else {
          this.$message.success(`批量创建全部成功！共创建 ${results.successList.length} 个广告`)
          this.dialogVisible = false
          await this.fetchAds()
        }
      } catch (err) {
        if (err !== 'cancel') {
          this.$message.error(err.message || '操作失败')
        }
      } finally {
        this.submitLoading = false
      }
    },

    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑广告'
      this.editAdId = row.smart_plus_ad_id

      // 如果后端返回了 creative_list，则使用它
      let creativeList = []
      if (row.creative_list && row.creative_list.length > 0) {
        creativeList = row.creative_list
      } else {
        // 兼容旧数据结构
        creativeList = [{
          ad_format: row.ad_format || 'SINGLE_VIDEO',
          video_info: {
            video_id: row.video_id || '',
            video_url: '',
            file_name: '',
            video_cover_url: row.video_cover_url || '',
            preview_url: row.preview_url || ''
          }
        }]
      }

      this.formData = {
        ad_name: row.ad_name || '',
        adgroup_ids: row.adgroup_id ? [row.adgroup_id] : [],
        operation_status: row.operation_status || 'ENABLE',
        creativeList: creativeList,
        ad_text_list: row.ad_text_list?.length ? row.ad_text_list : [{ad_text: ''}],
        call_to_action_list: row.call_to_action_list?.length ? row.call_to_action_list : [{call_to_action: ''}],
        landing_page_url_list: [{landing_page_url: row.landing_page_url || ''}]
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.adForm && this.$refs.adForm.clearValidate()
      })
    },
    async fetchCtaRecommendations() {
      try {
        const advertiserId = '7598883753192357896'
        const cacheKey = `cta_recommend_${advertiserId}`

        // 先从缓存读取
        const cached = localStorage.getItem(cacheKey)
        if (cached) {
          try {
            const { data, timestamp } = JSON.parse(cached)
            const cacheAge = Date.now() - timestamp
            const cacheExpiration = 24 * 60 * 60 * 1000 // 24小时

            if (cacheAge < cacheExpiration) {
              console.log('使用缓存的推荐文案')
              this.ctaRecommendList = data
              return
            } else {
              console.log('缓存已过期，重新获取')
              localStorage.removeItem(cacheKey)
            }
          } catch (e) {
            console.error('解析缓存失败', e)
            localStorage.removeItem(cacheKey)
          }
        }

        // 从服务器获取
        this.ctaLoading = true
        const res = await ctaApi.getRecommendCta({
          advertiserId,
          objectiveType: 'APP_PROMOTION',
          promotionType: 'MINI_GAME',
          language: 'en'
        })

        if (res.code === 0 && res.data?.recommend_assets) {
          this.ctaRecommendList = res.data.recommend_assets

          // 保存到缓存
          try {
            localStorage.setItem(cacheKey, JSON.stringify({
              data: res.data.recommend_assets,
              timestamp: Date.now()
            }))
          } catch (e) {
            console.error('缓存推荐文案失败', e)
          }
        } else {
          this.$message.warning('获取推荐文案失败')
        }
      } catch (error) {
        console.error('获取推荐文案失败', error)
        this.$message.error('获取推荐文案失败')
      } finally {
        this.ctaLoading = false
      }
    },

    handleCtaSelectionChange(selectedValues) {
      // selectedValues 是选中的 asset_content 数组
      this.selectedCtaList = selectedValues
    },

    async createPortfolioFromSelectedCta(advertiserId, selectedCtaList) {
      try {
        const cacheKey = `portfolio_cache_${advertiserId}_${JSON.stringify(selectedCtaList.sort())}`

        const cached = localStorage.getItem(cacheKey)
        if (cached) {
          try {
            const parsed = JSON.parse(cached)
            if (parsed && parsed.creative_portfolio_id && parsed.timestamp) {
              const now = Date.now()
              const cacheAge = now - parsed.timestamp
              const oneDay = 24 * 60 * 60 * 1000

              if (cacheAge < oneDay) {
                console.log('使用缓存的素材包ID:', parsed.creative_portfolio_id)
                return parsed.creative_portfolio_id
              } else {
                console.log('缓存已过期，将重新创建')
                localStorage.removeItem(cacheKey)
              }
            }
          } catch (e) {
            console.error('解析缓存失败', e)
            localStorage.removeItem(cacheKey)
          }
        }

        this.$message.info('正在创建素材包...')
        const portfolioContent = selectedCtaList.map(content => {
          const recommendItem = this.ctaRecommendList.find(item => item.asset_content === content)
          return {
            asset_content: content,
            asset_ids: recommendItem ? recommendItem.asset_ids : []
          }
        })

        const res = await ctaApi.createPortfolio({
          advertiserId,
          portfolioContent
        })

        if (res.code === 0 && res.data?.creative_portfolio_id) {
          const cacheData = {
            creative_portfolio_id: res.data.creative_portfolio_id,
            timestamp: Date.now(),
            selectedCtaList: selectedCtaList
          }
          localStorage.setItem(cacheKey, JSON.stringify(cacheData))
          console.log('素材包ID已缓存:', res.data.creative_portfolio_id)

          return res.data.creative_portfolio_id
        } else {
          throw new Error(res.message || '创建素材包失败')
        }
      } catch (error) {
        console.error('创建素材包失败', error)
        throw error
      }
    },

    // async handleSubmit() {
    //   try {
    //     await this.$refs.adForm.validate()
    //     this.submitLoading = true
    //
    //     const advertiserId = this.filter.advertiser_id
    //
    //     if (!this.formData.creativeList || this.formData.creativeList.length === 0) {
    //       this.$message.error('请至少上传一个视频')
    //       this.submitLoading = false
    //       return
    //     }
    //
    //     // 验证所有视频都有 video_id
    //     for (let i = 0; i < this.formData.creativeList.length; i++) {
    //       const creative = this.formData.creativeList[i]
    //       if (creative.ad_format === 'SINGLE_VIDEO' && !creative.video_info.video_id) {
    //         this.$message.warning(`第${i + 1}个视频素材不完整`)
    //         this.submitLoading = false
    //         return
    //       }
    //     }
    //
    //     // 如果选择了推荐文案，先创建素材包
    //     let callToActionId = null
    //     if (this.selectedCtaList && this.selectedCtaList.length > 0) {
    //       try {
    //         this.$message.info('正在创建素材包...')
    //         callToActionId = await this.createPortfolioFromSelectedCta(advertiserId)
    //         this.$message.success('素材包创建成功')
    //       } catch (error) {
    //         this.$message.error('创建素材包失败：' + error.message)
    //         this.submitLoading = false
    //         return
    //       }
    //     }
    //
    //     // 如果是编辑模式，只提交一次
    //     if (this.isEdit) {
    //       const requestData = {
    //         advertiserId,
    //         adgroup_id: this.formData.adgroup_ids[0],
    //         ad_name: this.formData.ad_name,
    //         creative_list: this.formData.creativeList,
    //         ad_text_list: this.formData.ad_text_list.filter(t => t.ad_text),
    //         landing_page_url_list: this.formData.landing_page_url_list.filter(item => item.landing_page_url),
    //         operation_status: this.formData.operation_status || 'ENABLE',
    //         smart_plus_ad_id: this.editAdId,
    //         ad_configuration: {
    //           dark_post_status: "ON"
    //         }
    //       }
    //
    //       if (callToActionId) {
    //         requestData.ad_configuration.call_to_action_id = callToActionId
    //       }
    //
    //       const res = await adApi.update(requestData)
    //       if (res.code === 0) {
    //         this.$message.success('编辑成功')
    //         this.dialogVisible = false
    //         await this.fetchAds()
    //       } else {
    //         this.$message.error(res.message || '操作失败')
    //       }
    //     } else {
    //       // 创建模式：批量创建广告
    //       const adgroupIds = this.formData.adgroup_ids
    //       const totalCount = adgroupIds.length
    //       let successCount = 0
    //       let failCount = 0
    //       const errors = []
    //
    //       this.$message.info(`正在批量创建广告（共 ${totalCount} 个）...`)
    //
    //       // 串行创建，避免并发请求过多
    //       for (let i = 0; i < adgroupIds.length; i++) {
    //         const adgroupId = adgroupIds[i]
    //         const adName = this.formData.ad_name || `广告_${adgroupId}_${Date.now()}`
    //
    //         const requestData = {
    //           advertiserId,
    //           adgroup_id: adgroupId,
    //           ad_name: adName,
    //           creative_list: this.formData.creativeList,
    //           ad_text_list: this.formData.ad_text_list.filter(t => t.ad_text),
    //           landing_page_url_list: this.formData.landing_page_url_list.filter(item => item.landing_page_url),
    //           operation_status: this.formData.operation_status || 'ENABLE',
    //           ad_configuration: {
    //             dark_post_status: "ON"
    //           }
    //         }
    //
    //         if (callToActionId) {
    //           requestData.ad_configuration.call_to_action_id = callToActionId
    //         }
    //
    //         try {
    //           const res = await adApi.create(requestData)
    //           if (res.code === 0) {
    //             successCount++
    //           } else {
    //             failCount++
    //             errors.push(`广告组 ${adgroupId}: ${res.message || '创建失败'}`)
    //           }
    //         } catch (error) {
    //           failCount++
    //           errors.push(`广告组 ${adgroupId}: ${error.message || '创建失败'}`)
    //         }
    //       }
    //
    //       // 显示批量创建结果
    //       if (failCount === 0) {
    //         this.$message.success(`批量创建成功！共创建 ${successCount} 个广告`)
    //         this.dialogVisible = false
    //         await this.fetchAds()
    //       } else if (successCount > 0) {
    //         this.$message.warning(`部分创建成功：成功 ${successCount} 个，失败 ${failCount} 个`)
    //         if (errors.length > 0) {
    //           console.error('创建失败的广告：', errors)
    //           this.$alert(errors.join('\n'), '创建失败详情', {
    //             confirmButtonText: '确定',
    //             type: 'warning'
    //           })
    //         }
    //         await this.fetchAds()
    //       } else {
    //         this.$message.error('批量创建失败：' + errors.join('; '))
    //       }
    //     }
    //   } catch (err) {
    //     if (err !== 'cancel') {
    //       this.$message.error(err.message || '操作失败')
    //     }
    //   } finally {
    //     this.submitLoading = false
    //   }
    // },

    handlePause(row) {
      this.$confirm('确定要暂停该广告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const advertiserId = row.advertiser_id
          const res = await adApi.updateStatus({
            advertiserId,
            smart_plus_ad_ids: [row.smart_plus_ad_id],
            operation_status: 'DISABLE'
          })
          if (res.code === 0) {
            this.$message.success('已暂停')
            await this.fetchAds()
          }
        } catch (error) {
          this.$message.error('操作失败')
        }
      }).catch(() => {
      })
    },

    handleResume(row) {
      this.$confirm('确定要启用该广告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {

          const res = await adApi.updateStatus({
            advertiser_id: row.advertiser_id,
            smart_plus_ad_ids: [row.smart_plus_ad_id],
            operation_status: 'ENABLE'
          })
          if (res.code === 0) {
            this.$message.success('已启用')
            await this.fetchAds()
          }
        } catch (error) {
          this.$message.error('操作失败')
        }
      }).catch(() => {
      })
    },

    handleDelete(row) {
      this.$confirm('删除后无法恢复，确定要删除该广告吗？', '警告', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        try {
          const advertiserId = this.filter.advertiser_id
          const res = await adApi.updateStatus({
            advertiserId,
            smart_plus_ad_ids: [row.smart_plus_ad_id],
            operation_status: 'DELETE'
          })
          if (res.code === 0) {
            this.$message.success('已删除')
            await this.fetchAds()
          }
        } catch (error) {
          this.$message.error('操作失败')
        }
      }).catch(() => {
      })
    },

    async handlePreview(row) {
      try {
        const res = await adApi.preview(row.advertiser_id, row.smart_plus_ad_id)
        if (res.code === 0 && res.data?.preview_link) {
          this.previewUrl = res.data.preview_link
          this.previewDialogVisible = true
        } else {
          this.$message.error('获取预览链接失败')
        }
      } catch (error) {
        this.$message.error('预览失败')
      }
    },

    copyPreviewLink() {
      this.copyToClipboard(this.previewUrl)
    },

    async handleViewReview(row) {

      // alert('暂未开放')
      this.currentReviewAdId = row.smart_plus_ad_id
      this.reviewDialogVisible = true
      this.appealForm = {reason: '', attachment: ''}

      try {
        const advertiserId = this.filter.advertiser_id
        const res = await adApi.getReviewInfo({
          advertiserId,
          smartPlusAdId: row.smart_plus_ad_id,
          includeRejectInfo: true
        })
        if (res.code === 0 && res.data?.smart_plus_ad_review_infos?.length) {
          this.reviewInfo = res.data.smart_plus_ad_review_infos[0]
        } else {
          this.reviewInfo = null
          this.$message.warning('暂无审核信息')
        }
      } catch (error) {
        this.$message.error('获取审核信息失败')
      }
    },

    async handleAppeal() {
      if (!this.appealForm.reason) {
        this.$message.warning('请填写申诉理由')
        return
      }

      try {
        const advertiserId = this.filter.advertiser_id
        const attachmentList = this.appealForm.attachment
            ? this.appealForm.attachment.split(',').map(s => s.trim())
            : []

        const res = await adApi.appeal({
          advertiserId,
          smart_plus_ad_id: this.currentReviewAdId,
          appeal_reason: this.appealForm.reason,
          attachment_list: attachmentList
        })

        if (res.code === 0) {
          this.$message.success('申诉已提交，请等待审核')
          this.reviewDialogVisible = false
          await this.fetchAds()
        } else {
          this.$message.error(res.message || '申诉失败')
        }
      } catch (error) {
        this.$message.error('申诉失败')
      }
    },
    handleDialogClose() {
      this.formData = {
        ad_name: '',
        adgroup_ids: [],
        operation_status: 'ENABLE',
        creativeList: [],
        ad_text_list: [{ad_text: ''}],
        call_to_action_list: [{call_to_action: ''}],
        landing_page_url_list: [{landing_page_url: ''}]
      }
      this.editAdId = null
    },

    formatTime(timeStr) {
      if (!timeStr) return '-'
      return timeStr.replace(' ', ' ')
    },

    getAdFormatLabel(format) {
      return AD_FORMAT_LABEL[format] || format || '-'
    },

    getAdFormatType(format) {
      const typeMap = {
        SINGLE_VIDEO: 'primary',
        CAROUSEL_ADS: 'success',
        CATALOG_CAROUSEL: 'warning'
      }
      return typeMap[format] || 'info'
    },

    getAppealStatusType(status) {
      const typeMap = {
        NOT_APPEALED: 'info',
        APPEALING: 'warning',
        APPEAL_SUCCESSFUL: 'success',
        APPEAL_FAILED: 'danger',
        APPEAL_DONE: 'info'
      }
      return typeMap[status] || 'info'
    },

    getAppealStatusLabel(status) {
      const labelMap = {
        NOT_APPEALED: '未申诉',
        APPEALING: '申诉中',
        APPEAL_SUCCESSFUL: '申诉成功',
        APPEAL_FAILED: '申诉失败',
        APPEAL_DONE: '申诉已完成'
      }
      return labelMap[status] || status
    },
    async retryCreateAd(failItem) {
      if (!failItem.requestData || !failItem.canRetry) {
        this.$message.warning('该广告无法重试')
        return
      }

      failItem.retrying = true
      this.retryingCount++

      try {
        const res = await adApi.create(failItem.requestData)
        if (res.code === 0) {
          this.$message.success(`窗口 ${failItem.windowIndex} - 广告 ${failItem.adIndex} 重试成功`)

          failItem.adId = res.data?.smart_plus_ad_id || '未知'
          this.submitResults.successList.push({
            windowIndex: failItem.windowIndex,
            adIndex: failItem.adIndex,
            adName: failItem.requestData.ad_name,
            adId: failItem.adId,
            advertiserId: failItem.advertiserId
          })

          const index = this.submitResults.failList.indexOf(failItem)
          if (index > -1) {
            this.submitResults.failList.splice(index, 1)
          }
        } else {
          this.$message.error(`重试失败: ${res.message}`)
          failItem.error = res.message || '重试失败'
        }
      } catch (error) {
        this.$message.error(`重试失败: ${error.message}`)
        failItem.error = error.message || '重试失败'
      } finally {
        failItem.retrying = false
        this.retryingCount--
      }
    },

    async retryAllFailedAds() {
      const retryableItems = this.submitResults.failList.filter(item => item.canRetry && !item.retrying)

      if (retryableItems.length === 0) {
        this.$message.warning('没有可重试的广告')
        return
      }

      this.retryingAll = true
      let successCount = 0
      let failCount = 0

      for (const item of retryableItems) {
        item.retrying = true
        try {
          const res = await adApi.create(item.requestData)
          if (res.code === 0) {
            successCount++
            this.submitResults.successList.push({
              windowIndex: item.windowIndex,
              adIndex: item.adIndex,
              adName: item.requestData.ad_name,
              adId: res.data?.smart_plus_ad_id || '未知',
              advertiserId: item.advertiserId
            })
            // 标记为成功，用于后续从失败列表中移除
            item._retrySuccess = true
          } else {
            failCount++
            item.error = res.message || '重试失败'
          }
        } catch (error) {
          failCount++
          item.error = error.message || '重试失败'
        } finally {
          item.retrying = false
        }
      }

      // 从失败列表中移除重试成功的项目
      this.submitResults.failList = this.submitResults.failList.filter(item => {
        return !item._retrySuccess
      })

      // 清理临时标记
      this.submitResults.failList.forEach(item => {
        delete item._retrySuccess
      })

      this.$message.success(`批量重试完成：成功 ${successCount} 个，仍失败 ${failCount} 个`)
      this.retryingAll = false
    },

    handleResultDialogConfirm() {
      this.submitResultDialogVisible = false
      this.dialogVisible = false
      this.fetchAds()
    },

    handleSubmitResultDialogClose() {
      this.activeResultTab = 'success'
      this.retryingAll = false
    },
    async handleAddVideosToLibrary(videos) {
      if (!videos || videos.length === 0) {
        return
      }




      let addedCount = 0
      let skippedCount = 0
      let uploadCoverCount = 0

      this.$message.info(`正在处理 ${videos.length} 个视频...`)

      for (const video of videos) {
        try {
          // 检查是否已存在
          const existingVideo = this.globalVideoLibrary.find(v => {
            const videoId = this.getVideoId(v)
            return videoId === video.videoId
          })

          if (existingVideo) {
            skippedCount++
            continue
          }

          // 构建素材库格式的视频对象
          const newCreative = {
            creative_info: {
              ad_format: 'SINGLE_VIDEO',
              video_info: {
                video_id: video.videoId,
                video_cover_url: video.coverUrl || '',
                preview_url: video.videoPreview || ''
              },
              image_info: [{web_uri: video.imageId}],
              identity_type: "BC_AUTH_TT",
              identity_id: "1d955ad7-cceb-539d-97e5-875db5b789f9",
              identity_authorized_bc_id: "7596985632614989825"
            },
            selected: false,
            file_name: video.info?.material_name || `video_${video.videoId}`
          }

          // 如果有封面URL但没有image_id，需要上传封面
          if (video.coverUrl&&!this.hasVideoCover(newCreative)) {
            try {
              await this.uploadGlobalVideoCover(newCreative, video.coverUrl, "7598883753192357896")
              if (this.hasVideoCover(newCreative)) {
                uploadCoverCount++
              }
            } catch (error) {
              console.error('上传封面失败', error)
            }
          }

          this.globalVideoLibrary.push(newCreative)
          addedCount++
        } catch (error) {
          console.error('添加视频到素材库失败', error)
        }
      }

      // 保存到缓存
      this.saveVideoLibraryToCache()

      // 显示结果
      let message = `成功添加 ${addedCount} 个视频到素材库`
      if (uploadCoverCount > 0) {
        message += `，上传了 ${uploadCoverCount} 个封面`
      }
      if (skippedCount > 0) {
        message += `，跳过 ${skippedCount} 个重复视频`
      }

      this.$message.success(message)
    },

  },
  filters: {
    truncate(str, len) {
      if (!str) return ''
      return str.length > len ? str.substring(0, len) + '...' : str
    }
  }
}
</script>

<style scoped>
/* ========== 页面整体布局 ========== */
.ad-list {
  padding: 16px;
  background: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #1f2f3d;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 10;
  position: relative;
}

.create-ad-btn {
  min-width: 130px;
  height: 36px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer !important;
  z-index: 10;
  position: relative;
  transition: all 0.3s ease;
}

.create-ad-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.create-ad-btn:active {
  transform: translateY(0);
}

/* ========== 筛选卡片 ========== */
.filter-card {
  margin-bottom: 16px;
}

.filter-card >>> .el-card__body {
  padding: 12px 16px;
}

/* 压缩筛选表单高度 */
.filter-card >>> .el-form--inline .el-form-item {
  margin-right: 12px;
  margin-bottom: 8px;
}

.filter-card >>> .el-form-item__label {
  padding: 0 8px 0 0;
  line-height: 32px;
  font-size: 13px;
}

.filter-card >>> .el-input__inner,
.filter-card >>> .el-select .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
}

.filter-card >>> .el-select {
  line-height: 32px;
}

.filter-card >>> .el-button {
  padding: 7px 15px;
  font-size: 13px;
  height: 32px;
}

.filter-card >>> .el-form-item__content {
  line-height: 32px;
}

/* ========== 表格样式优化 ========== */
.el-card {
  border-radius: 4px;
}

.el-card >>> .el-card__body {
  padding: 16px;
}

/* 表格响应式优化 */
.el-table {
  font-size: 14px;
}

.el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
  padding: 6px 0;
  height: 40px;
}

.el-table td {
  padding: 4px 0;
  height: 53px;
}

.el-table .cell {
  line-height: 1.3;
  padding: 2px 8px;
  box-sizing: border-box;
}

.el-table--medium .el-table__body td {
  padding: 3px 0;
  height: 48px;
}

.el-table--small .el-table__body td {
  padding: 2px 0;
  height: 44px;
}

.el-table__row {
  height: 53px;
  min-height: 53px;
}

.el-table__header th {
  padding: 6px 0;
  height: 40px;
}

/* ========== 广告信息单元格 ========== */
.ad-info-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0;
}

.ad-name-row {
  font-weight: 500;
  color: #303133;
  font-size: 13px;
  line-height: 1.2;
  word-break: break-word;
}

.ad-id-row {
  display: flex;
  align-items: center;
  gap: 3px;
}

.ad-id-text {
  //font-family: monospace;
  font-size: 11px;
  color: #909399;
  line-height: 1.3;
}

.ad-id-row:hover .copy-icon {
  opacity: 1;
}

/* ========== 复制图标 ========== */
.copy-icon {
  cursor: pointer;
  color: #909399;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.2s;
}

.id-cell:hover .copy-icon {
  opacity: 1;
}

.copy-icon:hover {
  color: #409eff;
}

/* ========== 文本样式 ========== */
.ad-name {
  font-weight: 400;
  color: #303133;
  line-height: 1.3;
}

.time-text {
  font-size: 12px;
  color: #606266;
  line-height: 1.3;
}

.id-text {
  font-size: 11px;
  color: #909399;
}

/* ========== 分页容器 ========== */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* ========== 操作按钮组 ========== */
.action-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
  z-index: 10;
}

.action-buttons .el-button {
  position: relative;
  z-index: 11;
}

.form-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

/* ========== 视频库相关样式 ========== */
.library-video-item .video-checkbox {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 10;
}

.library-video-item .no-cover-warning {
  position: absolute;
  top: 6px;
  right: 32px;
  z-index: 10;
  color: #f56c6c;
  font-size: 18px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 2px;
  animation: pulse 2s infinite;
}

.library-video-item .video-preview-wrapper {
  width: 100%;
  height: 90px;
  background-color: #000;
}

.library-video-item .reupload-cover-btn {
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  background-color: rgba(64, 158, 255, 0.9);
  color: #fff;
  border: 1px solid #409eff;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
}

.library-video-item:hover .reupload-cover-btn {
  opacity: 1;
}

.library-video-item .reupload-cover-btn:hover {
  background-color: rgba(64, 158, 255, 1);
}

.video-info-mini {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 8px;
  background-color: #f5f7fa;
  font-size: 11px;
}

.video-index {
  color: #909399;
  font-weight: 500;
}

.video-name {
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
}

.video-delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 18px;
  color: #909399;
  z-index: 10;
  padding: 4px;
}

.video-delete-btn:hover {
  color: #f56c6c;
}

.video-preview-wrapper {
  display: flex;
  gap: 12px;
  margin-right: 16px;
}

.video-cover img {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.video-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.video-info .file-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.video-info .cover-status {
  font-size: 12px;
  color: #67c23a;
}

.video-actions {
  display: flex;
  align-items: center;
}

/* ========== 上传区域样式 ========== */
.video-upload-area,
.image-upload-area {
  display: inline-block;
}

.upload-trigger {
  width: 200px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafafa;
  transition: all 0.3s;
}

.upload-trigger:hover {
  border-color: #409eff;
  background: #f0f7ff;
}

.upload-trigger i {
  font-size: 28px;
  color: #8c939d;
  margin-bottom: 8px;
}

.upload-trigger span {
  font-size: 12px;
  color: #606266;
}

.upload-trigger .tip {
  font-size: 10px;
  color: #c0c4cc;
  margin-top: 4px;
}

.video-preview {
  position: relative;
}

.video-preview video {
  border-radius: 4px;
}

.video-actions {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0 0 4px 4px;
}

.image-preview {
  position: relative;
  display: inline-block;
}

.image-actions {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0 0 4px 4px;
}

.carousel-upload-area {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.carousel-item {
  position: relative;
  width: 100px;
  height: 178px;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.carousel-actions {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0 0 4px 4px;
}

.carousel-upload {
  width: 100px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafafa;
}

.carousel-upload:hover {
  border-color: #409eff;
  background: #f0f7ff;
}

.carousel-upload i {
  font-size: 24px;
  color: #8c939d;
  margin-bottom: 8px;
}

.carousel-upload span {
  font-size: 12px;
  color: #606266;
}

/* ========== 广告文案列表 ========== */
.ad-text-list {
  width: 100%;
}

.ad-text-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.ad-text-item:last-child {
  margin-bottom: 0;
}

/* ========== 行动号召列表 ========== */
.cta-list {
  width: 100%;
}

.cta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.cta-item:last-child {
  margin-bottom: 0;
}

/* ========== UTM 参数 ========== */
.utm-params {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.utm-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* ========== 表单提示 ========== */
.form-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}

.tip {
  font-size: 12px;
  color: #c0c4cc;
  margin-left: 8px;
}

/* ========== 广告主选择区域 ========== */
.advertiser-select-area {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.advertiser-select {
  flex: 1;
  max-width: 600px;
}

/* ========== 批量模式样式 ========== */
.batch-mode-header {
  margin-bottom: 20px;
}

.batch-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.batch-count {
  margin-left: auto;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.form-container {
  max-height: 60vh;
  overflow-y: auto;
}

.form-container.batch-mode {
  max-height: none;
  overflow-y: visible;
}

.batch-forms-collapse {
  border: none;
}

.batch-form-item {
  margin-bottom: 16px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
}

.batch-form-item >>> .el-collapse-item__header {
  background-color: #f5f7fa;
  padding: 0 16px;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e4e7ed;
}

.batch-form-item >>> .el-collapse-item__wrap {
  border: none;
}

.batch-form-item >>> .el-collapse-item__content {
  padding: 20px;
}

.collapse-title {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.form-index {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.remove-form-btn {
  margin-left: auto;
  color: #f56c6c;
}

.remove-form-btn:hover {
  color: #ff0000;
}

.batch-single-form {
  padding: 8px 0;
}

.empty-batch-hint {
  padding: 60px 0;
  text-align: center;
}

/* ========== 预览弹窗 ========== */
.preview-container {
  text-align: center;
}

.preview-iframe-wrapper {
  margin-bottom: 16px;
}

.preview-iframe {
  width: 300px;
  height: 533px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
}

.preview-link {
  margin-top: 12px;
}

/* ========== 审核详情 ========== */
.review-info {
  padding: 8px 0;
}

.reject-info {
  margin-top: 20px;
}

.reject-info h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #f56c6c;
}

.reject-item {
  background: #fef0f0;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.reject-reasons,
.reject-suggestion {
  margin-bottom: 8px;
}

.reject-reasons .label,
.reject-suggestion .label {
  font-weight: 500;
  color: #606266;
}

.reject-reasons .value,
.reject-suggestion .value {
  color: #f56c6c;
}

/* ========== 分配配置卡片 ========== */
.allocation-config-card {
  background-color: #f0f9ff;
  border: 1px solid #d1e7ff;
}

.allocation-summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.allocation-summary .el-alert {
  margin-bottom: 0;
}

.allocation-summary .el-button {
  align-self: flex-start;
}

/* ========== 已分配视频预览 ========== */
.allocated-videos-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding: 8px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.allocated-video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.video-preview-mini {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  background-color: #000;
}

.video-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

.library-videos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  max-height: 350px;
  overflow-y: auto;
  padding: 8px;
}

.library-video-item {
  position: relative;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
  background-color: #fff;
}

.library-video-item:hover {
  border-color: #409eff;
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.3);
}

/* ========== 提交结果对话框 ========== */
.submit-result-dialog >>> .el-dialog__body {
  padding: 20px;
}

.result-summary {
  margin-bottom: 16px;
}

.empty-fail {
  padding: 40px 0;
  text-align: center;
}

/* ========== 新建广告组对话框 ========== */
.create-adgroup-dialog >>> .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
}

/* ========== 广告组选择器包装 ========== */
.adgroup-selector-wrapper {
  width: 100%;
}

/* ========== 库头部和操作 ========== */
.library-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.library-stats {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.library-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}


</style>
